/* eslint-disable */
/* tslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

/** Bank account representation containing balance information, account details, and operational status */
export type Account = {
  __typename?: 'Account';
  /** Retrieves transfer limits and current usage for the account, including daily/monthly ACH limits and amounts already transferred. Used for validating payment requests and displaying available limits to users. */
  accountLimits?: Maybe<AccountLimits>;
  /** Detailed account information including balance, account number, status, and configuration settings */
  attributes: AccountAttributes;
  /** Unique identifier for this bank account in the financial system */
  id: Scalars['ID'];
  /** Account resource type identifier (typically "account" for bank accounts) */
  type: Scalars['String'];
};

export type AccountAttributes = {
  __typename?: 'AccountAttributes';
  /** Bank account number - the unique numeric identifier for this account at the financial institution */
  accountNumber: Scalars['String'];
  /** Available balance in cents - the amount immediately accessible for spending, transfers, or withdrawals. Calculated as total balance minus any held or reserved funds. */
  available: Scalars['Float'];
  /** Total account balance in cents (includes both available funds and held amounts). This represents all money currently in the account, including funds that may be temporarily unavailable due to pending transactions or holds. */
  balance: Scalars['Float'];
  /** Current operational status indicating whether the account is active, restricted, or closed */
  status: AccountStatusEnum;
  /** Account metadata including purpose designation and tax withholding settings */
  tags: AccountTags;
};

/** Transfer limits and usage tracking for account operations like ACH transfers */
export type AccountLimits = {
  __typename?: 'AccountLimits';
  /** Detailed limit information including maximum amounts and current usage totals */
  attributes: AccountLimitsAttributes;
};

export type AccountLimitsAttributes = {
  __typename?: 'AccountLimitsAttributes';
  /** ACH transfer limits and current usage for this account */
  ach: AchLimits;
};

/** Defines the intended use of a bank account: Primary for main business operations, Tax for tax withholding funds, or other specialized purposes like savings buckets. */
export enum AccountPurposeEnum {
  LegacyPrimary = 'LegacyPrimary',
  LegacySavings = 'LegacySavings',
  LegacyTax = 'LegacyTax',
  Primary = 'Primary',
  Savings = 'Savings',
  Tax = 'Tax'
}

/** Current operational status of the bank account: Open (active and usable), Frozen (temporarily restricted), or Closed (permanently deactivated). */
export enum AccountStatusEnum {
  Closed = 'Closed',
  Frozen = 'Frozen',
  Open = 'Open'
}

export type AccountTags = {
  __typename?: 'AccountTags';
  /** The designated purpose of this account (primary business account, tax withholding account, etc.) */
  purpose: AccountPurposeEnum;
  /** Tax withholding percentage for automatic tax savings. Can be "smart" for AI-calculated rate, undefined for no withholding, or a decimal value between 0 and 1 for custom percentage. */
  taxWithholdingPercentage?: Maybe<Scalars['String']>;
};

/** Either Checking or Savings. */
export enum AccountType {
  Checking = 'Checking',
  Savings = 'Savings'
}

/** Complete banking and identification details for creating a payment recipient */
export type AchCounterPartyAttributesInput = {
  /** Bank account number for the recipient - checking or savings account where payments will be deposited */
  accountNumber: Scalars['String'];
  /** Type of bank account: Checking (most common for business payments) or Savings. Defaults to Checking. */
  accountType?: InputMaybe<AccountType>;
  /** Full legal name of the account holder - must match bank records exactly (individual name or business legal name) */
  name: Scalars['String'];
  /** Valid 9-digit ABA routing transit number identifying the recipient's bank - used for ACH routing verification */
  routingNumber: Scalars['String'];
  /** Optional metadata for organizing and categorizing this payment recipient including relationship type and contact information */
  tags?: InputMaybe<CounterpartyTagsInput>;
  /** Recipient entity type: Business (company/organization), Person (individual), or Unknown (when type cannot be determined) */
  type: CounterpartyType;
};

/** Complete input for creating a new payment recipient with banking details and metadata */
export type AchCounterPartyInput = {
  /** Banking details, contact information, and categorization data for the new payment recipient */
  attributes: AchCounterPartyAttributesInput;
};

export type AchCounterparty = {
  __typename?: 'AchCounterparty';
  /** JSON object representing the payment resource. */
  attributes: AchCounterpartyAttributes;
  /** Identifier of the ACH counterparty resource. */
  id: Scalars['ID'];
  /** Type of the ACH counterparty resource. */
  type: Scalars['String'];
};

export type AchCounterpartyAttributes = {
  __typename?: 'AchCounterpartyAttributes';
  /** Bank account number. */
  accountNumber: Scalars['String'];
  /** Either Checking or Savings. */
  accountType: AccountType;
  /** Name of the bank. */
  bank: Scalars['String'];
  /** The date the resource was created. */
  createdAt: Scalars['DateTime'];
  /** The account holder's name (whether an individual or a business). */
  name: Scalars['String'];
  /** Valid 9-digit ABA routing transit number. */
  routingNumber: Scalars['String'];
  /** Optional. Tags. */
  tags?: Maybe<CounterpartyTags>;
  /** Either Business, Person or Unknown. */
  type: CounterpartyType;
};

/** ACH payment attributes with inline counterparty information for one-time payments */
export type AchInlinePaymentAttributesInput = {
  /** Extended payment description (max 80 characters) providing additional context - not all banks display this information to recipients. */
  addenda?: InputMaybe<Scalars['String']>;
  /** Payment amount in cents (e.g., $100.00 = 10000 cents) */
  amount: Scalars['Int'];
  /** Banking details of the payment recipient including name, account number, and routing number */
  counterparty: CounterpartyInput;
  /** Short payment description (max 10 characters) that appears on the recipient's bank statement as Company Entry Description. Keep concise for compatibility. */
  description: Scalars['String'];
  /** Money flow direction: Credit (outgoing payment from your account) or Debit (incoming payment to your account). Defaults to Credit for typical payments. */
  direction?: InputMaybe<FundsFlowDirection>;
};

/** Input for creating ACH payments to new recipients with inline banking details */
export type AchInlinePaymentInput = {
  /** Unique identifier of the deposit account from which the payment will be sent */
  accountId: Scalars['ID'];
  /** Payment details including amount, descriptions, and recipient banking information */
  attributes: AchInlinePaymentAttributesInput;
};

export type AchLimits = {
  __typename?: 'AchLimits';
  /** Maximum allowed amounts for ACH credit transfers (incoming money) */
  limits: AchLimitsAttributes;
  /** Amount already transferred today - used to calculate remaining daily limit */
  totalsDaily: LimitTotalTransfer;
  /** Amount already transferred this month - used to calculate remaining monthly limit */
  totalsMonthly: LimitTotalTransfer;
};

export type AchLimitsAttributes = {
  __typename?: 'AchLimitsAttributes';
  /** Maximum amount in cents that can be received via ACH credit transfers in a single day */
  dailyCredit: Scalars['Float'];
  /** Maximum amount in cents that can be received via ACH credit transfers in a single month */
  monthlyCredit: Scalars['Float'];
};

/** Input for creating ACH payments to previously saved counterparties */
export type AchLinkedPaymentInput = {
  /** Unique identifier of the deposit account from which the payment will be sent */
  accountId: Scalars['ID'];
  /** Payment details including amount and descriptions - recipient info comes from saved counterparty */
  attributes: AchPaymentAttributesInput;
  /** Unique identifier of the saved counterparty to send the payment to */
  counterpartyId: Scalars['ID'];
};

/** ACH (Automated Clearing House) electronic payment for transferring money between bank accounts */
export type AchPayment = {
  __typename?: 'AchPayment';
  /** Detailed payment information including amount, status, counterparty details, and processing timeline */
  attributes: AchPaymentAttributes;
  /** Unique identifier for this ACH payment in the financial system */
  id: Scalars['ID'];
  /** Payment resource type identifier (typically "achPayment") */
  type: Scalars['String'];
};

/** ACH payment details including status, amount, counterparty, and processing information */
export type AchPaymentAttributes = {
  __typename?: 'AchPaymentAttributes';
  /** Extended payment description (max 50 characters) providing additional context - not all banks display this information */
  addenda?: Maybe<Scalars['String']>;
  /** Payment amount in cents (e.g., $100.00 = 10000 cents) */
  amount?: Maybe<Scalars['Int']>;
  /** Information about the recipient or sender of the ACH payment (name, account details, etc.) */
  counterparty: Counterparty;
  /** Timestamp when the ACH payment was initiated or created in the system */
  createdAt: Scalars['DateTime'];
  /** Short payment description (max 10 characters) that appears on the recipient's bank statement as the Company Entry Description */
  description: Scalars['String'];
  /** Money flow direction: Credit (incoming payment to your account) or Debit (outgoing payment from your account) */
  direction: FundsFlowDirection;
  /** Additional information about the payment status, especially useful for rejected or returned payments to explain the reason */
  reason?: Maybe<Scalars['String']>;
  /** Current processing status of the payment indicating its stage in the ACH transfer lifecycle */
  status: PaymentStatus;
};

/** Core ACH payment attributes including amount, direction, and descriptions that appear on bank statements */
export type AchPaymentAttributesInput = {
  /** Extended payment description (max 80 characters) providing additional context - not all banks display this information to recipients. */
  addenda?: InputMaybe<Scalars['String']>;
  /** Payment amount in cents (e.g., $100.00 = 10000 cents) */
  amount: Scalars['Int'];
  /** Short payment description (max 10 characters) that appears on the recipient's bank statement as Company Entry Description. Keep concise for compatibility. */
  description: Scalars['String'];
  /** Money flow direction: Credit (outgoing payment from your account) or Debit (incoming payment to your account). Defaults to Credit for typical payments. */
  direction?: InputMaybe<FundsFlowDirection>;
};

export type AchTransaction = Transaction & {
  __typename?: 'AchTransaction';
  /** Resolves the bank account identifier associated with this transaction, used for linking transactions to specific accounts and account-based filtering */
  accountId: Scalars['String'];
  attributes: AchTransactionAttributes;
  /** The expected completion date of the transaction */
  expectedCompletionDate?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this transaction in the financial system */
  id: Scalars['ID'];
  /** Resolves the HoneyBook project associated with this transaction for client billing and project cost tracking. Returns null if no project is linked or if project data cannot be retrieved. */
  project?: Maybe<Project>;
  /** The recurring payment ID connected to this transaction */
  recurringPaymentId?: Maybe<Scalars['String']>;
  /** Transaction type indicating the method of payment (e.g., "purchase" for card transactions, "originatedAch" for ACH transfers) */
  type: Scalars['String'];
  /** Resolves all automatic savings bucket withholdings made from this transaction, showing how money was distributed to tax and other savings buckets. Used for displaying savings allocation details. */
  withholdings?: Maybe<Array<BucketWithhold>>;
};

export type AchTransactionAttributes = {
  __typename?: 'AchTransactionAttributes';
  /** Additional transaction description. */
  addenda?: Maybe<Scalars['String']>;
  /** Transaction amount in cents (e.g., $12.34 = 1234 cents). Always positive regardless of direction. */
  amount: Scalars['Int'];
  /** Account balance in cents immediately after this transaction was processed */
  balance: Scalars['Int'];
  /** The category of the transaction */
  category?: Maybe<Scalars['String']>;
  /** The party on the other end of the transaction. */
  counterparty: AchTransactionCounterparty;
  /** Timestamp when the transaction was created or processed by the financial institution */
  createdAt: Scalars['DateTime'];
  /** Transaction description. */
  description: Scalars['String'];
  /** Direction of money movement: Credit (money coming in) or Debit (money going out of the account) */
  direction: FundsFlowDirection;
  /** The 3-letter ACH Standard Entry Class (SEC) Code (e.g. WEB, CCD, PPD, etc.). */
  secCode: Scalars['String'];
  /** Human-readable description of the transaction, typically including merchant name or transfer details */
  summary: Scalars['String'];
  /** Additional metadata including tax categorization, project association, and bucket withholding information */
  tags?: Maybe<TransactionTags>;
  /** The tax category of the transaction (actual or predicted). */
  taxCategory?: Maybe<Scalars['String']>;
  /** The title of the transaction */
  title: Scalars['String'];
  /** Optional. The 15-digit ACH Trace Number identifies the transaction within the ACH file after transmission. */
  traceNumber?: Maybe<Scalars['String']>;
};

export type AchTransactionCounterparty = {
  __typename?: 'AchTransactionCounterparty';
  /** Bank account number. */
  accountNumber: Scalars['String'];
  /** Either Checking or Savings. */
  accountType: Scalars['String'];
  /** Optional. See (this)[https://docs.unit.co/customer-api-tokens/#customers-create-customer-bearer-token-jwt] section for more information. */
  jwtSubject?: Maybe<Scalars['String']>;
  /** Name of the person or company that owns the bank account. */
  name: Scalars['String'];
  /** Valid 9-digit ABA routing transit number. */
  routingNumber: Scalars['String'];
};

/** Input for adding business relationship tags between customer and payment recipients */
export type AddCounterypartyRelationshipsArgs = {
  /** Array of business relationship identifiers to link with this customer (e.g., vendor categories, contractor types, service provider groups) */
  counterpartyRelationships: Array<Scalars['String']>;
  /** Optional customer identifier - defaults to current session customer if not provided */
  customerId?: InputMaybe<Scalars['ID']>;
};

export type Address = {
  __typename?: 'Address';
  /** City. */
  city: Scalars['String'];
  /** Two letters representing the country. */
  country: Scalars['String'];
  /** Postal code. */
  postalCode: Scalars['String'];
  /** State. For US addresses, two letters representing the state. */
  state?: Maybe<Scalars['String']>;
  /** First line of an address. */
  street: Scalars['String'];
  /** Optional. Second line of an address. */
  street2?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  /** City. */
  city: Scalars['String'];
  /** Two letters representing the country. */
  country: Scalars['String'];
  /** Postal code. */
  postalCode: Scalars['String'];
  /** State. For US addresses, two letters representing the state. */
  state?: InputMaybe<Scalars['String']>;
  /** First line of an address. */
  street: Scalars['String'];
  /** Optional. Second line of an address. */
  street2?: InputMaybe<Scalars['String']>;
};

/** Base interface for bank account applications. Applications are requests to open new business or individual accounts. */
export type Application = {
  /** Resolves the customer account created after successful application approval. Returns the full customer profile with account access and banking capabilities. Null if application is still pending or was rejected. */
  customer?: Maybe<Customer>;
  /** Unique identifier for this application in the system */
  id: Scalars['ID'];
  /** Type of application indicating whether it's for individual or business account */
  type: ApplicationType;
};

/** Current status of the bank account application: AwaitingDocuments (needs more paperwork), Canceled (user stopped process), PendingReview (under manual review), Pending (processing), Approved (accepted and account created), Denied (rejected). */
export enum ApplicationStatus {
  Approved = 'Approved',
  AwaitingDocuments = 'AwaitingDocuments',
  Canceled = 'Canceled',
  Denied = 'Denied',
  Pending = 'Pending',
  PendingReview = 'PendingReview'
}

/** Application metadata linking the request to HoneyBook accounts and containing banking details */
export type ApplicationTags = {
  __typename?: 'ApplicationTags';
  /** Bank account number for the account being applied for (when available) */
  accountNumber?: Maybe<Scalars['String']>;
  /** Financial technology platform customer identifier (internal banking system ID) */
  fintechCustomerId?: Maybe<Scalars['String']>;
  /** HoneyBook business account ID associated with this application */
  hbAccountId: Scalars['String'];
  /** HoneyBook member ID of the user submitting the application */
  memberId: Scalars['String'];
  /** Bank routing number for the account being applied for (when available) */
  routingNumber?: Maybe<Scalars['String']>;
};

/** Type of bank account application: individualApplication for personal/sole proprietor accounts, businessApplication for company accounts with multiple owners or employees. */
export enum ApplicationType {
  BusinessApplication = 'businessApplication',
  IndividualApplication = 'individualApplication'
}

export enum ApprovalStatus {
  Approved = 'Approved',
  Denied = 'Denied',
  PendingReview = 'PendingReview'
}

/** Card authorization representing a temporary hold placed on funds when a debit card is used, before the transaction is finalized */
export type Authorization = {
  __typename?: 'Authorization';
  /** Resolves the bank account identifier associated with this card authorization. Links the authorization to the specific business account that was charged for tracking and reconciliation purposes. */
  accountId: Scalars['String'];
  /** Detailed authorization information including amount, merchant, and payment method details */
  attributes: AuthorizationAttributes;
  /** Unique identifier for this authorization in the financial system */
  id: Scalars['ID'];
  /** Resolves the HoneyBook project associated with this card authorization for client billing and project expense tracking. Returns null if no project is linked to this transaction. */
  project?: Maybe<Project>;
  /** Resolves the tax category classification for this card authorization, used for expense categorization and tax reporting. Returns the business expense category (meals, travel, supplies, etc.) for proper tax deduction tracking. */
  taxCategory?: Maybe<Scalars['String']>;
  /** Authorization resource type identifier (typically "authorization") */
  type: Scalars['String'];
};

/** Card authorization details including amount, merchant information, and payment method used */
export type AuthorizationAttributes = {
  __typename?: 'AuthorizationAttributes';
  /** Authorization amount in cents - this is typically the amount held on the card before the final transaction settles */
  amount: Scalars['Int'];
  /** Last 4 digits of the debit card number used for this authorization (for identification and security purposes) */
  cardLast4Digits: Scalars['String'];
  /** Timestamp when the card authorization was created (when the merchant requested to hold funds) */
  createdAt: Scalars['DateTime'];
  /** Digital wallet service used for payment if applicable (Google Pay, Apple Pay, or other mobile payment method) */
  digitalWallet?: Maybe<DigitalWallet>;
  /** Information about the business or merchant where the card was used for this authorization */
  merchant: Merchant;
  /** How the card was used for payment: Manual (entered), Swipe (magnetic stripe), Contactless (tap), ChipAndPin (inserted), Stored (saved online), or Other */
  paymentMethod?: Maybe<PaymentMethod>;
};

export type AuthorizedUser = {
  __typename?: 'AuthorizedUser';
  /** The authorized user's email address. */
  email: Scalars['String'];
  /** Full name of the authorized user. */
  fullName: FullName;
  /** Optional */
  jwtSubject?: Maybe<Scalars['String']>;
  /** The authorized user's phone number. This number will be used for One Time Password (OTP) authentication. */
  phone: Phone;
};

/** Generic transaction type for financial activities that don't fall into specific categories like card purchases or ACH transfers. Includes basic transaction information without specialized fields. */
export type BaseTransaction = Transaction & {
  __typename?: 'BaseTransaction';
  /** Resolves the bank account identifier associated with this transaction, used for linking transactions to specific accounts and account-based filtering */
  accountId: Scalars['String'];
  /** Core transaction data including amount, direction, balance impact, merchant information, and metadata */
  attributes: TransactionAttributes;
  /** The expected completion date of the transaction */
  expectedCompletionDate?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this transaction in the financial system */
  id: Scalars['ID'];
  /** Resolves the HoneyBook project associated with this transaction for client billing and project cost tracking. Returns null if no project is linked or if project data cannot be retrieved. */
  project?: Maybe<Project>;
  /** The recurring payment ID connected to this transaction */
  recurringPaymentId?: Maybe<Scalars['String']>;
  /** Transaction type indicating the method of payment (e.g., "purchase" for card transactions, "originatedAch" for ACH transfers) */
  type: Scalars['String'];
  /** Resolves all automatic savings bucket withholdings made from this transaction, showing how money was distributed to tax and other savings buckets. Used for displaying savings allocation details. */
  withholdings?: Maybe<Array<BucketWithhold>>;
};

export type BeneficialOwner = {
  __typename?: 'BeneficialOwner';
  /** The beneficial owner's address. */
  address: Address;
  /** Date only */
  dateOfBirth: Scalars['Date'];
  /** The beneficial owner's email address. */
  email: Scalars['String'];
  /** Full name of the beneficial owner. */
  fullName: FullName;
  /** Only when Passport is populated. Two letters representing the beneficial owner's nationality" */
  nationality?: Maybe<Scalars['String']>;
  /** Passport of the beneficial owner. One of ssn or passport is required. */
  passport?: Maybe<Scalars['String']>;
  /** The beneficial owner percentage of ownership at the business (between 0 and 100). */
  percentage: Scalars['Int'];
  /** The beneficial owner's phone number. */
  phone: Phone;
  /** SSN of the beneficial owner (numbers only). One of ssn or passport is required. */
  ssn?: Maybe<Scalars['String']>;
  /** One of Approved, Denied or PendingReview. */
  status?: Maybe<ApprovalStatus>;
};

export type BeneficialOwnerInput = {
  /** The beneficial owner's address. */
  address: AddressInput;
  /** Date only */
  dateOfBirth: Scalars['String'];
  /** The beneficial owner's email address. */
  email: Scalars['String'];
  /** Full name of the beneficial owner. */
  fullName: FullNameInput;
  /** Only when Passport is populated. Two letters representing the beneficial owner's nationality" */
  nationality?: InputMaybe<Scalars['String']>;
  /** Passport of the beneficial owner. One of ssn or passport is required. */
  passport?: InputMaybe<Scalars['String']>;
  /** The beneficial owner percentage of ownership at the business (between 0 and 100). */
  percentage: Scalars['Int'];
  /** The beneficial owner's phone number. */
  phone: PhoneInput;
  /** SSN of the beneficial owner (numbers only). One of ssn or passport is required. */
  ssn?: InputMaybe<Scalars['String']>;
  /** One of Approved, Denied or PendingReview. */
  status?: InputMaybe<ApprovalStatus>;
};

/** Additional attributes for internal book payments between accounts */
export type BookPaymentAttributesInput = {
  /** Money flow direction for the internal transfer. Defaults to Credit. */
  direction?: InputMaybe<FundsFlowDirection>;
  /** Payment tags that will be copied to any transactions created by this internal transfer for tracking purposes */
  tags?: InputMaybe<PaymentTagsInput>;
};

/** Savings bucket for automatically setting aside money from transactions. Buckets help users save for taxes, emergencies, equipment, or other business goals. */
export type Bucket = {
  __typename?: 'Bucket';
  /** Visual icon identifier used in the UI to represent this bucket type (e.g., "tax", "emergency", "equipment") */
  icon: Scalars['String'];
  /** Unique identifier for this savings bucket */
  id: Scalars['ID'];
  /** Indicates if this is the special tax savings bucket used for automatic tax withholding calculations */
  isTaxBucket: Scalars['Boolean'];
  /** Previous smart tax rate calculation for backwards compatibility - used during migration from old tax calculation system */
  legacySmartTaxRate?: Maybe<Scalars['String']>;
  /** Display name for the bucket (e.g., "Tax Savings", "Emergency Fund", "Equipment Fund") */
  name: Scalars['String'];
  /** Current balance in cents accumulated in this bucket from automatic withholdings */
  savings: Scalars['Float'];
  /** Percentage of each transaction to automatically transfer to this bucket. Can be a decimal like "0.25" for 25%, or "smart" for AI-calculated tax withholding percentage. */
  savingsPercentage: Scalars['String'];
};

/** Status filter for savings buckets: active (currently operational), all (includes closed buckets), closed-with-balance (closed buckets that still have money) */
export enum BucketStatus {
  Active = 'Active',
  All = 'All',
  ClosedWithBalance = 'ClosedWithBalance'
}

/** Information about automatic money withholding to savings buckets when this transaction occurred */
export type BucketWithhold = {
  __typename?: 'BucketWithhold';
  /** Visual icon identifier representing the bucket type at the time of withholding */
  bucketIcon?: Maybe<Scalars['String']>;
  /** Name of the savings bucket that money was automatically transferred to (e.g., "Tax Savings", "Emergency Fund") */
  bucketName?: Maybe<Scalars['String']>;
  /** Amount in cents automatically withheld and transferred to the bucket for this transaction */
  withholdAmount?: Maybe<Scalars['Float']>;
  /** Percentage of the transaction amount that was withheld (e.g., "0.25" for 25% or "smart" for AI-calculated percentage) */
  withholdPercentage?: Maybe<Scalars['String']>;
};

export type BusinessApplication = Application & {
  __typename?: 'BusinessApplication';
  attributes: BusinessApplicationAttributes;
  /** Resolves the customer account created after successful application approval. Returns the full customer profile with account access and banking capabilities. Null if application is still pending or was rejected. */
  customer?: Maybe<Customer>;
  /** Unique identifier for this application in the system */
  id: Scalars['ID'];
  /** Type of application indicating whether it's for individual or business account */
  type: ApplicationType;
};

export type BusinessApplicationAttributes = {
  __typename?: 'BusinessApplicationAttributes';
  /** address of the business. */
  address: Address;
  /** Indicates whether the application has been archived. Archived applications are read-only and no changes can be made to them. An application becomes archived once the corresponding customer is archived. */
  archived: Scalars['Boolean'];
  /** Array of beneficial owners of the business. Beneficial Owner is anyone with more than 25% ownership. Beneficial Owners would need to go over KYC process and provide documents. */
  beneficialOwners: Array<BeneficialOwner>;
  /** Primary contact of the business. */
  contact: BusinessContact;
  /** Timestamp when the application was initially submitted */
  createdAt: Scalars['DateTime'];
  /** Optional. 'Doing business as'. */
  dba?: Maybe<Scalars['String']>;
  /** Business EIN (numbers only). */
  ein: Scalars['String'];
  /** One of 'Corporation', 'LLC' or 'Partnership'. */
  entityType: EntityType;
  /** Human-readable message providing details about the current status, next steps, or reasons for rejection/approval */
  message: Scalars['String'];
  /** Name of the business. */
  name: Scalars['String'];
  /** Officer representing the business, must be the CEO, COO, CFO, President, BenefitsAdministrationOfficer, CIO, VP, AVP, Treasurer, Secretary, Controller, Manager, Partner or Member. The officer would need to go over KYC process and provide documents. */
  officer: Officer;
  /** Phone of the business. */
  phone: Phone;
  /** Two letters representing a US state. */
  stateOfIncorporation: Scalars['String'];
  /** Current processing status of the application indicating what stage it's in and what actions may be needed */
  status: ApplicationStatus;
  /** Metadata connecting this application to HoneyBook accounts and containing banking information */
  tags: ApplicationTags;
};

/** Business information required for corporate entity bank account application and compliance verification */
export type BusinessApplicationAttributesInput = {
  /** Primary business address for legal correspondence and verification - cannot be a PO Box */
  address: AddressInput;
  /** Array of individuals who own 25% or more of the business, directly or indirectly - required by law for anti-money laundering compliance. Must provide complete personal information for each beneficial owner for KYC verification. */
  beneficialOwners?: InputMaybe<Array<BeneficialOwnerInput>>;
  /** Industry classification for the business (e.g., professional_services, retail, healthcare) - used for risk assessment and compliance requirements */
  businessVertical: Scalars['String'];
  /** Primary business contact person responsible for account management and authorized to act on behalf of the company */
  contact: BusinessContactInput;
  /** Doing Business As (DBA) name if the company operates under a different trade name than its legal name */
  dba?: InputMaybe<Scalars['String']>;
  /** Device fingerprint data for fraud prevention and security analysis during application process */
  deviceFingerprints?: InputMaybe<Array<DeviceFingerprintInput>>;
  /** Federal Employer Identification Number (EIN) assigned by the IRS - 9 digits, numbers only, required for business tax reporting */
  ein: Scalars['String'];
  /** Legal business entity type: Corporation (C-Corp/S-Corp), LLC (Limited Liability Company), or Partnership - determines regulatory requirements */
  entityType: EntityType;
  /** Unique key to prevent duplicate application submissions - ensures application is processed only once */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** IP address of the applicant submitting the application (IPv4 or IPv6) - critical for fraud prevention, geolocation verification, and compliance with banking regulations */
  ip?: InputMaybe<Scalars['String']>;
  /** Legal business name as registered with state authorities - must match incorporation documents exactly */
  name: Scalars['String'];
  /** Company officer (CEO, President, etc.) with authority to open bank accounts and conduct business on behalf of the entity */
  officer: OfficerInput;
  /** Primary business phone number for contact and verification during application processing */
  phone: PhoneInput;
  /** Two-letter US state code where the business is legally incorporated (e.g., "DE", "CA", "NY") - must match incorporation documents */
  stateOfIncorporation: Scalars['String'];
  /** Business website URL for verification and compliance checks - helps establish business legitimacy */
  website: Scalars['String'];
  /** Year the business was legally incorporated or formed - used for business age verification and risk assessment */
  yearOfIncorporation: Scalars['String'];
};

/** Complete input for business entity bank account application including corporate details, ownership structure, and optional external bank linking */
export type BusinessApplicationInput = {
  /** External bank account number for linking existing account - enables transfers between new HoneyBook account and external bank */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** Business information, ownership details, and compliance data required for corporate account application and verification */
  attributes: BusinessApplicationAttributesInput;
  /** Valid 9-digit ABA routing transit number for external bank - required if account number is provided for ACH transfers */
  routingNumber?: InputMaybe<Scalars['String']>;
};

export type BusinessContact = {
  __typename?: 'BusinessContact';
  /** The contact's email address. */
  email: Scalars['String'];
  /** Full name of the contact. */
  fullName: FullName;
  /** Optional */
  jwtSubject?: Maybe<Scalars['String']>;
  /** The contact's phone number. */
  phone: Phone;
};

export type BusinessContactInput = {
  /** The contact's email address. */
  email: Scalars['String'];
  /** Full name of the contact. */
  fullName: FullNameInput;
  /** Optional */
  jwtSubject?: InputMaybe<Scalars['String']>;
  /** The contact's phone number. */
  phone: PhoneInput;
};

export type BusinessCustomer = Customer & {
  __typename?: 'BusinessCustomer';
  attributes: BusinessCustomerAttributes;
  /** Unique identifier for the customer in the financial system */
  id: Scalars['ID'];
  /** Resolves the primary business bank account for this customer, used for main financial operations like payments, transactions, and savings bucket operations. Handles customer ID resolution and account lookup with proper error handling. */
  primaryAccount: Account;
  /** Indicates whether this is an individual or business customer account */
  type: CustomerTypeEnum;
};

export type BusinessCustomerAttributes = {
  __typename?: 'BusinessCustomerAttributes';
  /** address of the business. */
  address: Address;
  /** List of users authorized to perform financial operations on this customer account. These users can complete OTP verification for sensitive transactions like payments and transfers. */
  authorizedUsers?: Maybe<Array<AuthorizedUser>>;
  /** Primary contact of the business. */
  contact: BusinessContact;
  /** Timestamp when the customer account was first created in the financial system */
  createdAt: Scalars['DateTime'];
  /** Optional. 'Doing business as' */
  dba?: Maybe<Scalars['String']>;
  /** Business EIN (numbers only). */
  ein: Scalars['String'];
  /** One of 'Corporation', 'LLC' or 'Partnership'. */
  entityType: EntityType;
  /** Name of the business. */
  name: Scalars['String'];
  /** Phone of the business. */
  phone: Phone;
  /** Two letters representing a US state. */
  stateOfIncorporation: Scalars['String'];
  /** Metadata linking this financial customer to their HoneyBook account and member profile */
  tags: CustomerTags;
};

export type BusinessDebitCard = Card & {
  __typename?: 'BusinessDebitCard';
  /** JSON object representing the card data. */
  attributes: CardAttributes;
  /** Unique identifier for this debit card in the financial system */
  id: Scalars['ID'];
  /** Card type specifying the variant (businessDebitCard, individualVirtualDebitCard, etc.) */
  type: Scalars['String'];
};

export type BusinessVirtualDebitCard = Card & {
  __typename?: 'BusinessVirtualDebitCard';
  /** JSON object representing the card data. */
  attributes: BusinessVirtualDebitCardAttributes;
  /** Unique identifier for this debit card in the financial system */
  id: Scalars['ID'];
  /** Card type specifying the variant (businessDebitCard, individualVirtualDebitCard, etc.) */
  type: Scalars['String'];
};

export type BusinessVirtualDebitCardAttributes = {
  __typename?: 'BusinessVirtualDebitCardAttributes';
  /** Timestamp when the debit card was issued and created in the system */
  createdAt: Scalars['DateTime'];
  /** Card expiration date in YYYY-MM format (e.g., "2025-12" for December 2025) */
  expirationDate: Scalars['String'];
  /** Full name of the card holder. */
  fullName: Scalars['String'];
  /** Last 4 digits of the card number for identification purposes (e.g., "1234") */
  last4Digits: Scalars['String'];
  /** Current operational status of the card determining whether transactions are allowed */
  status: CardStatus;
};

/** Base card interface implemented by different card types (business/individual, physical/virtual debit cards) */
export type Card = {
  /** Unique identifier for this debit card in the financial system */
  id: Scalars['ID'];
  /** Card type specifying the variant (businessDebitCard, individualVirtualDebitCard, etc.) */
  type: Scalars['String'];
};

/** Input for performing actions on existing debit cards (freeze, unfreeze, close) */
export type CardActionInput = {
  /** Unique identifier of the debit card to perform the action on (freeze, unfreeze, or close) */
  cardId: Scalars['ID'];
};

/** Debit card details including status, expiration, and identification information */
export type CardAttributes = {
  __typename?: 'CardAttributes';
  /** Timestamp when the debit card was issued and created in the system */
  createdAt: Scalars['DateTime'];
  /** Card expiration date in YYYY-MM format (e.g., "2025-12" for December 2025) */
  expirationDate: Scalars['String'];
  /** Last 4 digits of the card number for identification purposes (e.g., "1234") */
  last4Digits: Scalars['String'];
  /** Current operational status of the card determining whether transactions are allowed */
  status: CardStatus;
};

/** Current status of the debit card: Active (usable for transactions), Inactive (temporarily disabled), Stolen/Lost (reported missing), Frozen (temporarily locked), ClosedByCustomer (permanently deactivated), SuspectedFraud (blocked due to security concerns). */
export enum CardStatus {
  Active = 'Active',
  ClosedByCustomer = 'ClosedByCustomer',
  Frozen = 'Frozen',
  Inactive = 'Inactive',
  Lost = 'Lost',
  Stolen = 'Stolen',
  SuspectedFraud = 'SuspectedFraud'
}

/** Complete cashflow summary showing income, expenses, and savings for a specific time period. Provides both high-level totals and detailed breakdowns by source/category. */
export type Cashflow = {
  __typename?: 'Cashflow';
  /** Net balance change in cents for the selected time period (income - expenses, not including savings which are separate) */
  balance: Scalars['Float'];
  /** Detailed breakdown of expense categories showing card transactions, ACH payments, ATM withdrawals, and other expenses */
  expenseDetails: ExpenseDetails;
  /** Total expenses amount in cents for the selected time period across all payment methods (cards, ACH, ATM, etc.) */
  expenses: Scalars['Float'];
  /** Total income amount in cents for the selected time period from all sources (client payments, transfers, etc.) */
  income: Scalars['Float'];
  /** Detailed breakdown of income sources showing client payments, ACH transfers, and other income categories */
  incomeDetails: IncomeDetails;
  /** Total savings amount in cents automatically set aside during the selected time period through bucket withholding */
  savings: Scalars['Float'];
  /** Detailed breakdown of automatic savings showing tax withholding and other bucket allocations */
  savingsDetails: SavingsDetails;
};

/** Represents a chart with its datasets */
export type Chart = {
  __typename?: 'Chart';
  /** The collection of datasets that the chart contains. */
  datasets: Array<Dataset>;
  /** Human-readable text indicating when the data was last refreshed. */
  refreshTimestampHumanized?: Maybe<Scalars['String']>;
};

/** Client Token input */
export type ConnectFinancialAccountsInput = {
  /** active account ids received from plaid client SDK after a successful connection */
  accounts: Array<ConnectedFinancialAccount>;
  /** institution id received from plaid client SDK after a successful connection */
  institutionId: Scalars['String'];
  /** institution name received from plaid client SDK after a successful connection */
  institutionName: Scalars['String'];
  /** client token received from plaid client SDK after a successful connection */
  token: Scalars['String'];
};

/** Connected account */
export type ConnectedFinancialAccount = {
  /** account id */
  id: Scalars['String'];
  /** last 4 digits of the account number */
  last4: Scalars['String'];
  /** account name */
  name: Scalars['String'];
  /** account subtype */
  subtype?: InputMaybe<Scalars['String']>;
  /** account type */
  type?: InputMaybe<Scalars['String']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  /** The latitude value. */
  latitude: Scalars['Float'];
  /** The longitude value. */
  longitude: Scalars['Float'];
};

export type Counterparty = {
  __typename?: 'Counterparty';
  /** Bank account number. */
  accountNumber: Scalars['String'];
  /** Either Checking or Savings. */
  accountType: AccountType;
  /** Approval status of counterparty. */
  approvalStatus: Scalars['String'];
  /**
   * Name of the person or company that owns the bank account.
   *
   */
  name: Scalars['String'];
  /** Valid 9-digit ABA routing transit number. */
  routingNumber: Scalars['String'];
};

/** Approval status of counterparty. */
export enum CounterpartyApprovalStatus {
  Approved = 'Approved',
  Denied = 'Denied',
  Pending = 'Pending'
}

export type CounterpartyInput = {
  /** Bank account number. */
  accountNumber: Scalars['String'];
  /** Either Checking or Savings. */
  accountType: AccountType;
  /**
   * Name of the person or company that owns the bank account.
   *
   */
  name: Scalars['String'];
  /** Valid 9-digit ABA routing transit number. */
  routingNumber: Scalars['String'];
};

export type CounterpartyTags = {
  __typename?: 'CounterpartyTags';
  /** The approve status tag of a counterparty */
  approvalStatus?: Maybe<CounterpartyApprovalStatus>;
  /** The email tag of a counterparty */
  email?: Maybe<Scalars['String']>;
  /** The relationship tag of a counterparty */
  relationship?: Maybe<Scalars['String']>;
};

/** Metadata tags for categorizing and organizing payment recipients */
export type CounterpartyTagsInput = {
  /** Contact email address for the payment recipient - used for communication and record keeping */
  email?: InputMaybe<Scalars['String']>;
  /** Business relationship type (e.g., "vendor", "contractor", "service_provider", "freelancer", "supplier") */
  relationship?: InputMaybe<Scalars['String']>;
};

/** Either Business, Person or Unknown. */
export enum CounterpartyType {
  Business = 'Business',
  Person = 'Person',
  Unknown = 'Unknown'
}

/** Input for creating internal transfers between accounts within the same banking system */
export type CreateBookPaymentInput = {
  /** Transfer amount in cents (e.g., $50.00 = 5000 cents) */
  amount: Scalars['Int'];
  /** Optional transfer attributes including direction and tags for categorization */
  attributes?: InputMaybe<BookPaymentAttributesInput>;
  /** Transfer description (max 50 characters) that will appear on account statements for both source and destination accounts */
  description: Scalars['String'];
  /** Destination account identifier to which money will be transferred */
  destinationAccountId: Scalars['ID'];
  /** Source account identifier from which money will be transferred */
  sourceAccountId: Scalars['ID'];
};

/** Input data for creating a new business expense record with tax categorization and project linking capabilities */
export type CreateExpenseInput = {
  /** Expense amount in cents (e.g., $25.99 = 2599 cents) */
  amount: Scalars['Int'];
  /** Date when the expense was incurred (not necessarily when recorded) */
  date: Scalars['Date'];
  /** Name of the business or merchant where the expense occurred (e.g., "Office Depot", "Delta Airlines") */
  merchant: Scalars['String'];
  /** Additional notes or description providing context about the business purpose of this expense */
  notes?: InputMaybe<Scalars['String']>;
  /** HoneyBook project identifier if this expense should be allocated to a specific client project for billing or cost tracking */
  projectId?: InputMaybe<Scalars['String']>;
  /** Tax classification for this expense (office supplies, travel, meals, etc.) used for tax deduction calculations */
  taxCategory?: InputMaybe<TaxCategoryEnum>;
  /** HoneyBook user identifier for expense attribution and reporting purposes */
  userId?: InputMaybe<Scalars['String']>;
};

/** Base customer interface representing either an individual or business customer in the financial system */
export type Customer = {
  /** Unique identifier for the customer in the financial system */
  id: Scalars['ID'];
  /** Resolves the primary business bank account for this customer, used for main financial operations like payments, transactions, and savings bucket operations. Handles customer ID resolution and account lookup with proper error handling. */
  primaryAccount: Account;
  /** Indicates whether this is an individual or business customer account */
  type: CustomerTypeEnum;
};

export type CustomerTags = {
  __typename?: 'CustomerTags';
  /** HoneyBook account identifier - the business account ID within HoneyBook platform */
  hbAccountId: Scalars['String'];
  /** HoneyBook member identifier - links this financial customer to their HoneyBook user account */
  memberId: Scalars['String'];
};

/** Secure authentication token for customer verification in sensitive financial operations */
export type CustomerToken = {
  __typename?: 'CustomerToken';
  /** Token expiration time in seconds - used for automatic token refresh and security validation */
  expiresIn?: Maybe<Scalars['Float']>;
  /** Indicates if the token value is masked for security (true) or fully visible (false) */
  isMasked: Scalars['Boolean'];
  /** Authentication token string - may be masked or full token depending on security context */
  token?: Maybe<Scalars['String']>;
};

/** Purpose for customer authentication token creation - defines what sensitive operation the token will authorize (payments, transfers, account changes) */
export enum CustomerTokenPurpose {
  FullPrivileges = 'FullPrivileges',
  ReadCardDetails = 'ReadCardDetails',
  TransferMoney = 'TransferMoney'
}

/** Type of customer account: Individual for personal freelancers/sole proprietors, or Business for companies with multiple owners, employees, or corporate structure. */
export enum CustomerTypeEnum {
  Business = 'Business',
  Individual = 'Individual'
}

/** Represents an individual data point within a dataset. */
export type DataPoint = {
  __typename?: 'DataPoint';
  /** The amount of objects in the data point. */
  count: Scalars['Float'];
  /** The label for the data point, such as a category name or timestamp. */
  label: Scalars['String'];
  /** The numerical value of the data point. */
  value: Scalars['Float'];
};

/** Represents a dataset within a chart, including its data points and styling. */
export type Dataset = {
  __typename?: 'Dataset';
  /** The data points that make up the dataset. */
  data: Array<DataPoint>;
  /** The label for the dataset, used in legends and tooltips. */
  label: Scalars['String'];
};

export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

/** Input for creating a new debit card (physical or virtual) linked to a specific account */
export type DebitCardInput = {
  /** Bank account identifier that the debit card will be linked to for spending and transaction access */
  accountId: Scalars['ID'];
  /** Optional customer identifier - defaults to current session customer if not provided */
  customerId?: InputMaybe<Scalars['ID']>;
};

/** Input for permanently deleting a saved payment recipient */
export type DeleteAchCounterypartyArgs = {
  /** Unique identifier of the payment recipient to delete - this will also cancel any associated recurring payments */
  counterpartyId: Scalars['ID'];
};

/** Input data for permanently deleting an expense record from the system */
export type DeleteExpenseInput = {
  /** Unique identifier of the expense record to permanently delete */
  id: Scalars['ID'];
};

/** Input for permanently deleting a yearly revenue goal and all associated progress data */
export type DeleteGoalInput = {
  /** Unique identifier of the revenue goal to permanently remove from the system */
  id: Scalars['ID'];
};

/** Response for delete worker operation */
export type DeleteWorkerResponse = {
  __typename?: 'DeleteWorkerResponse';
  /** Optional message providing additional details about the operation */
  errorMessage?: Maybe<Scalars['String']>;
  /** Whether the delete operation was successful */
  success: Scalars['Boolean'];
};

export type DeviceFingerprintInput = {
  /** Provider of the device fingerprint fraud and risk prevention. The value is always iovation */
  provider: Scalars['String'];
  /** The device fingerprint blackbox value. */
  value: Scalars['String'];
};

export enum DigitalWallet {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Other = 'OTHER'
}

export type Employer = {
  __typename?: 'Employer';
  /** Account status of the employer. */
  employerAccountStatus: EmployerAccountStatus;
  /** External ID of the employer. */
  externalId: Scalars['String'];
  /** Identifier of the employer. */
  id: Scalars['ID'];
  /** Type of payroll workforce (W2, Contractor, or Both). */
  payrollType: PayrollType;
};

/** The status of the employer account. */
export enum EmployerAccountStatus {
  Active = 'ACTIVE',
  Onboarding = 'ONBOARDING',
  Pending = 'PENDING'
}

export type EmployerToken = {
  __typename?: 'EmployerToken';
  /** The expiration date of the token. */
  expiration: Scalars['DateTime'];
  /** The token string. */
  token: Scalars['String'];
};

export enum EntityType {
  Corporation = 'Corporation',
  Llc = 'LLC',
  Partnership = 'Partnership'
}

/** Business expense record for tax reporting and financial tracking. Expenses can be categorized, linked to projects, and associated with payment sources. */
export type Expense = {
  __typename?: 'Expense';
  /** Expense amount in cents (e.g., $25.99 = 2599 cents) */
  amount: Scalars['Int'];
  /** Date when the expense was incurred (not necessarily when it was recorded) */
  date: Scalars['Date'];
  /** Unique identifier for this expense record in the system */
  id: Scalars['ID'];
  /** Name of the business or merchant where the expense occurred (e.g., "Office Depot", "Delta Airlines") */
  merchant: Scalars['String'];
  /** User-added notes or description providing additional context about the expense */
  notes?: Maybe<Scalars['String']>;
  /** Resolves the HoneyBook project associated with this expense for client billing and project cost tracking. Returns null if no project is linked or if the project cannot be found. */
  project?: Maybe<Project>;
  /** HoneyBook project identifier if this expense should be allocated to a specific client project for billing or tracking */
  projectId?: Maybe<Scalars['String']>;
  /** Payment method information including the card or account used to make this expense */
  source?: Maybe<ExpenseSourceDetails>;
  /** Tax classification for this expense (office supplies, travel, meals, etc.) used for tax deduction calculations */
  taxCategory?: Maybe<TaxCategoryEnum>;
};

/** Breakdown of business expenses showing how money was spent during the selected time period */
export type ExpenseDetails = {
  __typename?: 'ExpenseDetails';
  /** Total amount in cents sent via ACH payments (one-time bank transfers to vendors, contractors, etc.) */
  achPayment: Scalars['Float'];
  /** Total amount in cents spent through ACH transactions (automated bank transfers for recurring expenses) */
  achTransaction: Scalars['Float'];
  /** Total amount in cents withdrawn from ATMs for cash expenses */
  atmTransaction: Scalars['Float'];
  /** Total amount in cents spent using debit cards for purchases, meals, supplies, and other business expenses */
  cardTransaction: Scalars['Float'];
  /** Total amount in cents for expenses from other payment methods not categorized above */
  miscellaneous: Scalars['Float'];
};

/** Information about the payment method or account used for this expense */
export type ExpenseSourceDetails = {
  __typename?: 'ExpenseSourceDetails';
  /** Plaid financial connection ID associated with this expense */
  connectionId?: Maybe<Scalars['String']>;
  /** Unique identifier of the payment source (card ID, account ID, etc.) */
  id: Scalars['String'];
  /** Last 4 digits of the payment method (card number, account number) for identification purposes */
  last4: Scalars['String'];
  /** Display name of the payment source (e.g., "Business Debit Card", "Primary Account") */
  name: Scalars['String'];
};

export type ExternalAccount = {
  __typename?: 'ExternalAccount';
  /** Available balance */
  availableBalance: Scalars['Float'];
  /** Current balance */
  currentBalance: Scalars['Float'];
  /** Official account name */
  displayName: Scalars['String'];
  /** Institution ID */
  institutionId: Scalars['String'];
  /** Institution name */
  institutionName?: Maybe<Scalars['String']>;
  /** The date the account was last updated */
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /** Logo of institution associated with the external account. */
  logo?: Maybe<Scalars['String']>;
  /** The link status of this account */
  status: PlaidInstitutionAuthStatus;
  /** Account subtype */
  subtype: Scalars['String'];
};

/** External financial account connection (bank account, credit card, etc.) linked to the business for transaction import and synchronization */
export type FinancialConnection = {
  __typename?: 'FinancialConnection';
  /** ISO 8601 timestamp indicating when the financial connection was created */
  createdAt: Scalars['String'];
  /** Unique identifier for this connected financial account */
  id: Scalars['String'];
  /** Additional information about the connection status, especially useful for error or disconnected states */
  reason?: Maybe<Scalars['String']>;
  /** Current connection status indicating whether the account is actively syncing transactions */
  status: FinancialConnectionStatus;
};

/** Status of a financial account connection: Connected (active and syncing), Disconnected (requires re-authentication), Error (connection failed), or Pending (being established). */
export enum FinancialConnectionStatus {
  Active = 'ACTIVE',
  Disconnected = 'DISCONNECTED',
  DisconnectedManually = 'DISCONNECTED_MANUALLY',
  Downgraded = 'DOWNGRADED',
  Pending = 'PENDING'
}

/** Collection of external financial accounts connected to the business for automated transaction import and financial data synchronization */
export type FinancialConnections = {
  __typename?: 'FinancialConnections';
  /** Returns the auth token to use for bank connection client sdk (Stripe/Plaid) */
  authToken: Scalars['ID'];
  /** List of all external financial accounts currently connected to this business */
  connections: Array<FinancialConnection>;
};

export type FinancialInsight = {
  __typename?: 'FinancialInsight';
  /** When this insight was generated. */
  createdAt: Scalars['DateTime'];
  /** Detailed description of the financial insight. */
  description: Scalars['String'];
  /** Friendly version of the insight. */
  friendlyInsight: Scalars['String'];
  /** Identifier of the financial insight. */
  id: Scalars['ID'];
  /** The reasoning behind why this insight was generated. */
  rationale: Array<Scalars['String']>;
  /** The user's reaction to this insight. */
  reaction: InsightReaction;
  /** Recommended action based on this financial insight. */
  recommendation: Scalars['String'];
  /** Title of the financial insight. */
  title: Scalars['String'];
  /** The type of the insight. */
  type: InsightType;
};

export type FullName = {
  __typename?: 'FullName';
  /** Individual first name. */
  first: Scalars['String'];
  /** Individual last name. */
  last: Scalars['String'];
};

export type FullNameInput = {
  /** Individual first name. */
  first: Scalars['String'];
  /** Individual last name. */
  last: Scalars['String'];
};

/** The direction in which the funds flow- Debit or Credit. */
export enum FundsFlowDirection {
  Credit = 'Credit',
  Debit = 'Debit'
}

/** Base interface for financial goals like revenue targets, savings goals, or expense limits. Goals track progress toward specific financial objectives over defined time periods. */
export type Goal = {
  /** End date of the goal tracking period in ISO format (e.g., "2024-12-31") */
  endDate: Scalars['Date'];
  /** Unique identifier for this goal in the system */
  id: Scalars['ID'];
  /** Start date of the goal tracking period in ISO format (e.g., "2024-01-01") */
  startDate: Scalars['Date'];
  /** Target amount to achieve for this goal (e.g., $50,000 annual revenue = 50000.00) */
  target: Scalars['Float'];
  /** HoneyBook user ID of the person who set this goal */
  userId: Scalars['ID'];
};

/** Input for creating a new yearly revenue goal with target amount for business planning and performance tracking */
export type GoalInput = {
  /** Target annual revenue amount in dollars (e.g., 100000.00 for $100,000 yearly goal) */
  target: Scalars['Float'];
};

/** Current status of a financial goal: IN_PROGRESS (actively working toward target), ACHIEVED (target reached), NOT_ACHIEVED (target not met by end date), NOT_SET (no goal configured). */
export enum GoalStatus {
  Achieved = 'ACHIEVED',
  InProgress = 'IN_PROGRESS',
  NotAchieved = 'NOT_ACHIEVED',
  NotSet = 'NOT_SET'
}

export type HbSubscription = {
  __typename?: 'HBSubscription';
  /** The payment method for the subscription plan. */
  paymentMethod?: Maybe<SubscriptionPaymentMethod>;
  /** The subscription plan for the user. */
  plan?: Maybe<SubscriptionPlan>;
  state?: Maybe<SubscriptionState>;
};

/** Breakdown of income sources showing how money comes into the business during the selected time period */
export type IncomeDetails = {
  __typename?: 'IncomeDetails';
  /** Total income in cents from client payments processed through HoneyBook or other payment systems */
  clientPayments: Scalars['Float'];
  /** Total income in cents from other sources not categorized as client payments or ACH transfers */
  miscellaneous: Scalars['Float'];
  /** Total income in cents from ACH transfers received (bank-to-bank transfers, wire transfers, etc.) */
  receivedAchTransaction: Scalars['Float'];
};

export type IndividualApplication = Application & {
  __typename?: 'IndividualApplication';
  attributes: IndividualApplicationAttributes;
  /** Resolves the customer account created after successful application approval. Returns the full customer profile with account access and banking capabilities. Null if application is still pending or was rejected. */
  customer?: Maybe<Customer>;
  /** Unique identifier for this application in the system */
  id: Scalars['ID'];
  /** Type of application indicating whether it's for individual or business account */
  type: ApplicationType;
};

export type IndividualApplicationAttributes = {
  __typename?: 'IndividualApplicationAttributes';
  /** address of the individual. */
  address: Address;
  /** Timestamp when the application was initially submitted */
  createdAt: Scalars['DateTime'];
  /** Date only */
  dateOfBirth: Scalars['Date'];
  /** Optional. Indicates if the individual is a sole proprietor who is doing business under a different name, if specified. */
  dba?: Maybe<Scalars['String']>;
  /** Optional. Indicates if the individual is a sole proprietor who has an Employer Identification Number, if specified. */
  ein?: Maybe<Scalars['String']>;
  /** Email address of the individual. */
  email: Scalars['String'];
  /** Only when Passport is populated. Two letters representing the individual nationality. */
  fullName: FullName;
  /** IP address of the end-customer creating the application, if specified. */
  ip?: Maybe<Scalars['String']>;
  /** Human-readable message providing details about the current status, next steps, or reasons for rejection/approval */
  message: Scalars['String'];
  /** Only when Passport is populated. Two letters representing the individual nationality. */
  nationality?: Maybe<Scalars['String']>;
  /** Individual passport number. Either ssn or passport will be populated. */
  passport?: Maybe<Scalars['String']>;
  /** Phone of the individual. */
  phone: Phone;
  /** Optional. Indicates whether the individual is a sole proprietor, if specified. */
  soleProprietorship?: Maybe<Scalars['Boolean']>;
  /** SSN of the individual (numbers only). Either ssn or passport will be populated. */
  ssn?: Maybe<Scalars['String']>;
  /** Current processing status of the application indicating what stage it's in and what actions may be needed */
  status: ApplicationStatus;
  /** Metadata connecting this application to HoneyBook accounts and containing banking information */
  tags: ApplicationTags;
};

/** Personal information required for individual customer bank account application and KYC verification */
export type IndividualApplicationAttributesInput = {
  /** Current residential address of the individual - used for identity verification and compliance checks */
  address: AddressInput;
  /** Industry classification for the business (e.g., professional_services, retail, healthcare) - used for risk assessment and compliance requirements */
  businessVertical: Scalars['String'];
  /** Date of birth in YYYY-MM-DD format - used for age verification and compliance with banking regulations (must be 18+) */
  dateOfBirth: Scalars['String'];
  /** Doing Business As (DBA) name for sole proprietors operating under a business name different from their legal name */
  dba?: InputMaybe<Scalars['String']>;
  /** Device fingerprint data for fraud prevention and security analysis during application process */
  deviceFingerprints?: InputMaybe<Array<DeviceFingerprintInput>>;
  /** Employer Identification Number (EIN) for sole proprietors with business tax ID - 9 digits, numbers only, used for business tax reporting */
  ein?: InputMaybe<Scalars['String']>;
  /** Primary email address for account communications, verification codes, and important banking notifications */
  email: Scalars['String'];
  /** Complete legal name of the individual applicant - must match government-issued identification documents exactly for verification */
  fullName: FullNameInput;
  /** Unique key to prevent duplicate application submissions - ensures application is processed only once */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** IP address of the applicant submitting the application (IPv4 or IPv6) - critical for fraud prevention, geolocation verification, and compliance with banking regulations */
  ip?: InputMaybe<Scalars['String']>;
  /** Two-letter country code representing nationality (e.g., "CA", "GB") - required when passport is provided instead of SSN */
  nationality?: InputMaybe<Scalars['String']>;
  /** Passport number for non-US citizens applying for business banking - alternative to SSN for identity verification */
  passport?: InputMaybe<Scalars['String']>;
  /** Primary phone number for contact and verification purposes during application processing */
  phone: PhoneInput;
  /** Indicates if the applicant operates as a sole proprietor business - affects tax reporting and business classification */
  soleProprietorship?: InputMaybe<Scalars['Boolean']>;
  /** Social Security Number (9 digits, numbers only) for US citizens and residents - required for identity verification and tax reporting. Use passport for non-US applicants. */
  ssn?: InputMaybe<Scalars['String']>;
  /** Business website URL for verification and compliance checks - helps establish business legitimacy */
  website: Scalars['String'];
};

/** Complete input for individual customer bank account application including personal details and optional external bank linking */
export type IndividualApplicationInput = {
  /** External bank account number for linking existing account - enables transfers between new HoneyBook account and external bank */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** Personal information and business details required for individual account application and KYC verification */
  attributes: IndividualApplicationAttributesInput;
  /** Valid 9-digit ABA routing transit number for external bank - required if account number is provided for ACH transfers */
  routingNumber?: InputMaybe<Scalars['String']>;
};

export type IndividualCustomer = Customer & {
  __typename?: 'IndividualCustomer';
  attributes: IndividualCustomerAttributes;
  /** Unique identifier for the customer in the financial system */
  id: Scalars['ID'];
  /** Resolves the primary business bank account for this customer, used for main financial operations like payments, transactions, and savings bucket operations. Handles customer ID resolution and account lookup with proper error handling. */
  primaryAccount: Account;
  /** Indicates whether this is an individual or business customer account */
  type: CustomerTypeEnum;
};

export type IndividualCustomerAttributes = {
  __typename?: 'IndividualCustomerAttributes';
  /** address of the individual. */
  address: Address;
  /** List of users authorized to perform financial operations on this customer account. These users can complete OTP verification for sensitive transactions like payments and transfers. */
  authorizedUsers?: Maybe<Array<AuthorizedUser>>;
  /** Timestamp when the customer account was first created in the financial system */
  createdAt: Scalars['DateTime'];
  dateOfBirth: Scalars['Date'];
  /** Email address of the individual. */
  email: Scalars['String'];
  /** Full name of the individual. */
  fullName: FullName;
  /** Only when Passport is populated. Two letters representing the individual nationality */
  nationality?: Maybe<Scalars['String']>;
  /** Individual passport number. Either ssn or passport will be populated. */
  passport?: Maybe<Scalars['String']>;
  /** Phone of the individual. */
  phone: Phone;
  /** Individual ssn number. Either ssn or passport will be populated. */
  ssn?: Maybe<Scalars['String']>;
  /** Metadata linking this financial customer to their HoneyBook account and member profile */
  tags: CustomerTags;
};

export type IndividualDebitCard = Card & {
  __typename?: 'IndividualDebitCard';
  /** JSON object representing the card data. */
  attributes: CardAttributes;
  /** Unique identifier for this debit card in the financial system */
  id: Scalars['ID'];
  /** Card type specifying the variant (businessDebitCard, individualVirtualDebitCard, etc.) */
  type: Scalars['String'];
};

export type IndividualVirtualDebitCard = Card & {
  __typename?: 'IndividualVirtualDebitCard';
  /** JSON object representing the card data. */
  attributes: CardAttributes;
  /** Unique identifier for this debit card in the financial system */
  id: Scalars['ID'];
  /** Card type specifying the variant (businessDebitCard, individualVirtualDebitCard, etc.) */
  type: Scalars['String'];
};

/** The possible reactions a user can have to an insight */
export enum InsightReaction {
  Dislike = 'DISLIKE',
  Like = 'LIKE',
  None = 'NONE'
}

/** The type of financial insight */
export enum InsightType {
  Capital = 'CAPITAL',
  Default = 'DEFAULT',
  Pricing = 'PRICING',
  Services = 'SERVICES'
}

export enum Interval {
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export type LimitTotalTransfer = {
  __typename?: 'LimitTotalTransfer';
  /** Total amount in cents already transferred via ACH credits within the current time period */
  credits: Scalars['Float'];
};

export type Merchant = {
  __typename?: 'Merchant';
  /** The merchant category, described by the MCC code */
  category: Scalars['String'];
  /** Optional. The location (city, state, etc.) of the merchant */
  location?: Maybe<Scalars['String']>;
  /** The name of the merchant. */
  name: Scalars['String'];
  /** The 4-digit ISO 18245 merchant category code (MCC). */
  type: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Adds business relationship tags to link customer with payment recipients (vendors, contractors, freelancers). Used for organizing and categorizing payment relationships for better financial management and reporting. */
  addCounterpartyRelationships: Array<Scalars['String']>;
  /** Adds a worker to a specified project. */
  addWorkerToProject: Scalars['Boolean'];
  /** Creates a new bank account application for business entities (LLCs, corporations, partnerships). Handles business verification, compliance checks, and account setup with optional external bank account linking for business transfers. */
  businessApplication: BusinessApplication;
  /** Close a bucket and transfer its balance to the customer's primary account */
  closeBucket: Account;
  /** Permanently closes a debit card, preventing all future transactions. This action cannot be undone. Use when a card is compromised, no longer needed, or when replacing with a new card. */
  closeCard: Card;
  /** Sends a Plaid client token from the client to the server for logging/verification; returns true on success. */
  connectFinancialAccounts: Scalars['Boolean'];
  /** Links a card authorization to a HoneyBook project for client billing and expense tracking. Automatically updates associated transactions with project information for accurate project cost management and client invoicing. */
  connectProjectToAuthorization: Authorization;
  /** Creates an internal transfer between two accounts within the same banking system. Used for moving money between primary account and savings buckets, or between different account purposes. */
  createBookPayment: AchPayment;
  /** Creates a new payment recipient (counterparty) with their banking details for future ACH payments. Used for saving vendor, contractor, or service provider information to enable recurring payments without re-entering banking details. */
  createCounterParty: AchCounterparty;
  /** Creates a secure customer authentication token using two-factor verification for sensitive financial operations. Includes rate limiting protection and requires valid verification code from createTokenVerification. Used for authorizing payments, transfers, and account modifications. */
  createCustomerToken?: Maybe<CustomerToken>;
  /** Creates a physical debit card that will be mailed to the customer address. Provides full spending access including ATM withdrawals and in-person transactions. Automatically configures individual or business card based on customer type with appropriate cardholder details. */
  createDebitCard: Card;
  /** Create an employer user token for the given employer ID. */
  createEmployerUserToken: EmployerToken;
  /** Creates a new business expense record for tax reporting and financial tracking. Automatically triggers expense events for integrations and notifications. Requires Owner, Bookkeeper, or SuperAdmin permissions. */
  createExpense: Expense;
  /** Creates an ACH payment to a new recipient by providing their banking details inline. Used for one-time payments to vendors or contractors without saving their information as a permanent counterparty. */
  createInlinePayment: AchPayment;
  /** Creates an ACH payment to a previously saved counterparty using their stored banking information. Used for recurring payments to regular vendors, contractors, or service providers. */
  createLinkedPayment?: Maybe<AchPayment>;
  /** Create a new payroll employer. */
  createNewPayrollEmployer: Employer;
  /** Create a recurring ACH credit payment. */
  createRecurringAchCreditPayment: RecurringAchCreditPayment;
  /** Creates a new savings bucket for automatic money allocation from transactions. For tax buckets, this reopens or adjusts the tax withholding account. Each bucket automatically saves a percentage of incoming transactions for specific purposes like taxes, emergencies, or equipment. */
  createSavingsBucket: Bucket;
  /** Initiates two-factor authentication by sending a verification code via SMS or phone call. Required first step before creating customer tokens for sensitive operations like payments or account changes. Returns verification token for subsequent token creation. */
  createTokenVerification?: Maybe<Scalars['String']>;
  /** Creates a virtual debit card for immediate online and digital spending. Virtual cards provide instant access to account funds without waiting for physical card delivery. Automatically handles individual vs business customer requirements and cardholder information. */
  createVirtualDebitCard: Card;
  /** Creates a new annual revenue target for business planning and performance tracking. Helps users set realistic income goals based on their business growth objectives and historical performance. */
  createYearlyRevenueGoal: YearlyRevenueGoal;
  /** Permanently deletes a saved payment recipient and automatically cancels any associated recurring payments. This action cannot be undone. Use when a vendor/contractor relationship ends or banking details are no longer valid. */
  deleteCounterparty: Scalars['ID'];
  /** Permanently deletes an expense record from the system. This action cannot be undone and triggers deletion events for audit purposes. Returns true if successful. Requires Owner, Bookkeeper, or SuperAdmin permissions. */
  deleteExpense: Scalars['Boolean'];
  /** Delete plaid institution auth */
  deletePlaidInstitutionAuth: Scalars['Boolean'];
  /** Delete a worker. */
  deleteWorker: DeleteWorkerResponse;
  /** Permanently removes the yearly revenue goal from the system. This action cannot be undone and will clear all associated progress tracking and historical data. */
  deleteYearlyRevenueGoal: Scalars['Boolean'];
  /** Disconnects a financial connection by starting a temporal workflow to remove the Plaid connection. */
  disconnectFinancialConnection: Scalars['Boolean'];
  /** Exchange public token with link token */
  exchangePublicToken: Scalars['Boolean'];
  /** Temporarily freezes a debit card to prevent all transactions while keeping the card active. Use for suspected fraud, lost cards, or temporary spending restrictions. Card can be unfrozen later to restore full functionality. */
  freezeCard: Card;
  generateReport: ReportDownload;
  /** Creates a new bank account application for individual customers (sole proprietors, freelancers). Initiates the KYC verification process and account setup with optional external bank account linking for transfers. */
  individualApplication: IndividualApplication;
  /** Exchange public token with link token */
  markItemRepaired: Scalars['Boolean'];
  /** Removes business relationship tags between customer and payment recipients. Used when ending vendor/contractor relationships or reorganizing payment recipient categories for cleaner financial management. */
  removeCounterpartyRelationships: Array<Scalars['String']>;
  /** Remove a worker to a specified project. */
  removeWorkerFromProject: Scalars['Boolean'];
  /** Save a UI preference. */
  saveUIPreference: UiPreference;
  /** Sets the annual revenue target for the current year. Creates a new goal if none exists, or updates the existing one. This idempotent operation ensures users can only have one goal per year. */
  setYearlyRevenueGoal: YearlyRevenueGoal;
  /** Initializes the primary bank account for a new customer during onboarding. Creates the main business account that will be used for transactions, payments, and savings bucket operations. */
  setupAccounts: Array<Account>;
  /** Toggle activation status */
  toggleRecurringAchCreditPaymentActivationStatus: RecurringAchCreditPayment;
  /** Transfer a bucket's account to the customer's primary account */
  transferBucketBalance: Bucket;
  /** Transfer a bucket's account to the customer's primary account */
  transferFromBucketBalance: Bucket;
  /** Transfer a bucket's account to the customer's primary account */
  transferToBucketBalance: Bucket;
  /** Unfreezes a previously frozen debit card, restoring full transaction capabilities. Use after resolving fraud concerns, finding a lost card, or removing temporary spending restrictions. */
  unfreezeCard: Card;
  /** Updates account configuration, primarily used for modifying tax withholding settings. Triggers tax withholding change events when percentage is modified for compliance and notification purposes. */
  updateAccount: Account;
  /** Updates the tax category classification for a card authorization to ensure proper expense categorization for tax reporting. Automatically applies the tax category to associated transactions for accurate financial records. */
  updateAuthorizationTaxCategory: Authorization;
  /** Updates bucket configuration including savings percentage, name, and icon. Changes to savings percentage affect future transaction withholdings but do not retroactively adjust existing savings. */
  updateBucket: Bucket;
  /** Updates saved payment recipient information including relationship tags and contact details. Used for maintaining accurate vendor/contractor information and business relationship categorization for reporting and organization. */
  updateCounterparty: AchCounterparty;
  /** Updates an existing expense record with new information such as amount, tax category, or project assignment. Triggers update events for audit trails and integrations. Requires Owner, Bookkeeper, or SuperAdmin permissions. */
  updateExpense: Expense;
  /** Update the payroll subscription for the current user. */
  updatePayrollSubscription: Scalars['Boolean'];
  /** Updates transaction metadata including tax categories, project assignments, and custom tags. Used for categorizing transactions for tax reporting and business analysis. */
  updateTransaction: Transaction;
  /** Updates the target amount for an existing yearly revenue goal. Allows users to adjust their financial targets based on changing business conditions or performance insights. */
  updateYearlyRevenueGoal: YearlyRevenueGoal;
};


export type MutationAddCounterpartyRelationshipsArgs = {
  data: AddCounterypartyRelationshipsArgs;
};


export type MutationAddWorkerToProjectArgs = {
  projectId: Scalars['ID'];
  workerId: Scalars['ID'];
};


export type MutationBusinessApplicationArgs = {
  data: BusinessApplicationInput;
};


export type MutationCloseBucketArgs = {
  bucketId: Scalars['String'];
  transferBalance?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCloseCardArgs = {
  data: CardActionInput;
};


export type MutationConnectFinancialAccountsArgs = {
  data: ConnectFinancialAccountsInput;
};


export type MutationConnectProjectToAuthorizationArgs = {
  authorizationId: Scalars['ID'];
  customerId?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
};


export type MutationCreateBookPaymentArgs = {
  data: CreateBookPaymentInput;
};


export type MutationCreateCounterPartyArgs = {
  data: AchCounterPartyInput;
};


export type MutationCreateCustomerTokenArgs = {
  customerId?: InputMaybe<Scalars['ID']>;
  fingerprint?: InputMaybe<Scalars['ID']>;
  purpose: CustomerTokenPurpose;
  verificationCode: Scalars['ID'];
  verificationToken: Scalars['ID'];
};


export type MutationCreateDebitCardArgs = {
  data: DebitCardInput;
};


export type MutationCreateExpenseArgs = {
  data: CreateExpenseInput;
};


export type MutationCreateInlinePaymentArgs = {
  data: AchInlinePaymentInput;
};


export type MutationCreateLinkedPaymentArgs = {
  data: AchLinkedPaymentInput;
};


export type MutationCreateNewPayrollEmployerArgs = {
  payrollType: PayrollType;
};


export type MutationCreateRecurringAchCreditPaymentArgs = {
  data: RecurringAchCreditPaymentInput;
};


export type MutationCreateSavingsBucketArgs = {
  bucketIcon: Scalars['String'];
  bucketName: Scalars['String'];
  bucketSavingsPercentage: Scalars['String'];
  customerId?: InputMaybe<Scalars['ID']>;
  isTaxBucket: Scalars['Boolean'];
};


export type MutationCreateTokenVerificationArgs = {
  channel: UnitVerificationTokenChannel;
  customerId?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateVirtualDebitCardArgs = {
  data: DebitCardInput;
};


export type MutationCreateYearlyRevenueGoalArgs = {
  data: GoalInput;
};


export type MutationDeleteCounterpartyArgs = {
  data: DeleteAchCounterypartyArgs;
};


export type MutationDeleteExpenseArgs = {
  data: DeleteExpenseInput;
};


export type MutationDeletePlaidInstitutionAuthArgs = {
  institutionId: Scalars['String'];
};


export type MutationDeleteWorkerArgs = {
  workerId: Scalars['ID'];
};


export type MutationDeleteYearlyRevenueGoalArgs = {
  data: DeleteGoalInput;
};


export type MutationDisconnectFinancialConnectionArgs = {
  connectionId: Scalars['String'];
};


export type MutationExchangePublicTokenArgs = {
  activeAccountIds: Array<Scalars['String']>;
  institutionId: Scalars['String'];
  institutionName: Scalars['String'];
  token: Scalars['String'];
};


export type MutationFreezeCardArgs = {
  data: CardActionInput;
};


export type MutationGenerateReportArgs = {
  filters: ReportFiltersInput;
};


export type MutationIndividualApplicationArgs = {
  data: IndividualApplicationInput;
};


export type MutationMarkItemRepairedArgs = {
  activeAccountIds: Array<Scalars['String']>;
  institutionId: Scalars['String'];
};


export type MutationRemoveCounterpartyRelationshipsArgs = {
  data: RemoveCounterypartyRelationshipsArgs;
};


export type MutationRemoveWorkerFromProjectArgs = {
  projectId: Scalars['ID'];
  workerId: Scalars['ID'];
};


export type MutationSaveUiPreferenceArgs = {
  input: SaveUiPreferenceInput;
};


export type MutationSetYearlyRevenueGoalArgs = {
  data: GoalInput;
};


export type MutationToggleRecurringAchCreditPaymentActivationStatusArgs = {
  data: ToggleRecurringPaymentStatusInput;
};


export type MutationTransferBucketBalanceArgs = {
  bucketId: Scalars['String'];
};


export type MutationTransferFromBucketBalanceArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  bucketId: Scalars['String'];
};


export type MutationTransferToBucketBalanceArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  bucketId: Scalars['String'];
};


export type MutationUnfreezeCardArgs = {
  data: CardActionInput;
};


export type MutationUpdateAccountArgs = {
  data: UpdateAccountInput;
};


export type MutationUpdateAuthorizationTaxCategoryArgs = {
  authorizationId: Scalars['ID'];
  taxCategory: TaxCategoryEnum;
};


export type MutationUpdateBucketArgs = {
  bucketIcon?: InputMaybe<Scalars['String']>;
  bucketId: Scalars['String'];
  bucketName?: InputMaybe<Scalars['String']>;
  savingsPercentage?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCounterpartyArgs = {
  data: UpdateAchCounterypartyArgs;
};


export type MutationUpdateExpenseArgs = {
  data: UpdateExpenseInput;
};


export type MutationUpdatePayrollSubscriptionArgs = {
  subscribe: Scalars['Boolean'];
};


export type MutationUpdateTransactionArgs = {
  data: UpdateTransactionInput;
};


export type MutationUpdateYearlyRevenueGoalArgs = {
  data: UpdateGoalInput;
};

export type Officer = {
  __typename?: 'Officer';
  /** The officer's address. */
  address: Address;
  /** Date only */
  dateOfBirth: Scalars['Date'];
  /** The officer's email address. */
  email: Scalars['String'];
  /** Full name of the officer. */
  fullName: FullName;
  /** Only when Passport is populated. Two letters representing the officer's nationality. */
  nationality?: Maybe<Scalars['String']>;
  /** Passport of the officer. One of ssn or passport is required. */
  passport?: Maybe<Scalars['String']>;
  /** The officer's phone number. */
  phone: Phone;
  /** SSN of the officer (numbers only). One of ssn or passport is required. */
  ssn?: Maybe<Scalars['String']>;
  /** One of Approved, Denied or PendingReview. */
  status?: Maybe<ApprovalStatus>;
  /** One of CEO, COO, CFO, President, BenefitsAdministrationOfficer, CIO, VP, AVP, Treasurer, Secretary, Controller, Manager, Partner or Member. */
  title: OfficerTitle;
};

export type OfficerInput = {
  /** The officer's address. */
  address: AddressInput;
  /** Date only */
  dateOfBirth: Scalars['String'];
  /** The officer's email address. */
  email: Scalars['String'];
  /** Full name of the officer. */
  fullName: FullNameInput;
  /** Only when Passport is populated. Two letters representing the officer's nationality. */
  nationality?: InputMaybe<Scalars['String']>;
  /** Passport of the officer. One of ssn or passport is required. */
  passport?: InputMaybe<Scalars['String']>;
  /** The officer's phone number. */
  phone: PhoneInput;
  /** SSN of the officer (numbers only). One of ssn or passport is required. */
  ssn?: InputMaybe<Scalars['String']>;
  /** One of Approved, Denied or PendingReview. */
  status?: InputMaybe<ApprovalStatus>;
  /** One of CEO, COO, CFO, President, BenefitsAdministrationOfficer, CIO, VP, AVP, Treasurer, Secretary, Controller, Manager, Partner or Member. */
  title: OfficerTitle;
};

export enum OfficerTitle {
  Avp = 'AVP',
  BenefitsAdministrationOfficer = 'BenefitsAdministrationOfficer',
  Ceo = 'CEO',
  Cfo = 'CFO',
  Cio = 'CIO',
  Coo = 'COO',
  Controller = 'Controller',
  Manager = 'Manager',
  Member = 'Member',
  Partner = 'Partner',
  President = 'President',
  Secretary = 'Secretary',
  Treasurer = 'Treasurer',
  Vp = 'VP'
}

/** Response structure for paginated expenses query */
export type PaginatedExpensesResponse = {
  __typename?: 'PaginatedExpensesResponse';
  /** The list of expenses for the requested page */
  expenses: Array<Expense>;
  /** The total number of expenses matching the filter criteria */
  totalCount: Scalars['Int'];
};

export enum PaymentMethod {
  ChipAndPin = 'CHIP_AND_PIN',
  Contactless = 'CONTACTLESS',
  Manual = 'MANUAL',
  Other = 'OTHER',
  Stored = 'STORED',
  Swipe = 'SWIPE'
}

/** Current status of an ACH payment: Pending (initiated but not processed), PendingReview (requires manual approval), Rejected (denied by bank or system), Clearing (in transit), Sent (successfully completed), Canceled (stopped before processing), Returned (failed and money returned). */
export enum PaymentStatus {
  Canceled = 'Canceled',
  Clearing = 'Clearing',
  Pending = 'Pending',
  PendingReview = 'PendingReview',
  Rejected = 'Rejected',
  Returned = 'Returned',
  Sent = 'Sent'
}

/** Tags to attach to payments for categorization and tracking */
export type PaymentTagsInput = {
  /** Payment purpose tag (e.g., "vendor_payment", "contractor_fee", "bucket_transfer") */
  purpose: Scalars['String'];
};

export type PayrollSubscription = {
  __typename?: 'PayrollSubscription';
  /** The account ID of the payroll subscription. */
  account_id: Scalars['String'];
  /** Whether the user is subscribed to payroll. */
  subscribed: Scalars['Boolean'];
};

/** The type of payroll workforce */
export enum PayrollType {
  Both = 'Both',
  Contractor = 'Contractor',
  W2 = 'W2'
}

export type Phone = {
  __typename?: 'Phone';
  /** Country code of the phone number. */
  countryCode: Scalars['String'];
  /** The phone number without the country code. */
  number: Scalars['String'];
};

export type PhoneInput = {
  /** Country code of the phone number. */
  countryCode: Scalars['String'];
  /** The phone number without the country code. */
  number: Scalars['String'];
};

/** The status of the institution authentication */
export enum PlaidInstitutionAuthStatus {
  AboutToExpire = 'AboutToExpire',
  Deleted = 'Deleted',
  NeedRelogin = 'NeedRelogin',
  Ok = 'Ok',
  PendingData = 'PendingData'
}

export type Project = {
  __typename?: 'Project';
  /** Identifier of the HB project resource. */
  id: Scalars['ID'];
  /** The image URL of the HB project resource. */
  imageUrl?: Maybe<Scalars['String']>;
  /** Whether the HB project resource is deleted. */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** The name of the HB project resource. */
  name: Scalars['String'];
  /** The stage of the HB project resource. */
  stage?: Maybe<Scalars['String']>;
  /** The workspace id of the HB project resource. */
  workspaceId?: Maybe<Scalars['String']>;
};

export type ProjectCashflow = {
  __typename?: 'ProjectCashflow';
  /** Net profit for this project (total payments - total expenses) */
  netProfit: Scalars['Float'];
  /** Number of expenses for this project */
  numExpenses: Scalars['Int'];
  /** Number of payments for this project */
  numPayments: Scalars['Int'];
  /** Total expenses for this project */
  totalExpenses: Scalars['Float'];
  /** Total payments received for this project */
  totalPayments: Scalars['Float'];
};

export type PurchaseTransaction = Transaction & {
  __typename?: 'PurchaseTransaction';
  /** Resolves the bank account identifier associated with this transaction, used for linking transactions to specific accounts and account-based filtering */
  accountId: Scalars['String'];
  attributes: PurchaseTransactionAttributes;
  /** The expected completion date of the transaction */
  expectedCompletionDate?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this transaction in the financial system */
  id: Scalars['ID'];
  /** Resolves the HoneyBook project associated with this transaction for client billing and project cost tracking. Returns null if no project is linked or if project data cannot be retrieved. */
  project?: Maybe<Project>;
  /** The recurring payment ID connected to this transaction */
  recurringPaymentId?: Maybe<Scalars['String']>;
  /** Transaction type indicating the method of payment (e.g., "purchase" for card transactions, "originatedAch" for ACH transfers) */
  type: Scalars['String'];
  /** Resolves all automatic savings bucket withholdings made from this transaction, showing how money was distributed to tax and other savings buckets. Used for displaying savings allocation details. */
  withholdings?: Maybe<Array<BucketWithhold>>;
};

export type PurchaseTransactionAttributes = {
  __typename?: 'PurchaseTransactionAttributes';
  /** Transaction amount in cents (e.g., $12.34 = 1234 cents). Always positive regardless of direction. */
  amount: Scalars['Int'];
  /** Account balance in cents immediately after this transaction was processed */
  balance: Scalars['Int'];
  /** The last 4 digits of the debit card involved in the transaction. */
  cardLast4Digits: Scalars['String'];
  /** The category of the transaction */
  category?: Maybe<Scalars['String']>;
  /** Coordinates (latitude, longitude) of where the purchase took place. */
  coordinates?: Maybe<Coordinates>;
  /** Timestamp when the transaction was created or processed by the financial institution */
  createdAt: Scalars['DateTime'];
  /** The type of digital wallet used, one of: Google, Apple, Other. */
  digitalWallet?: Maybe<DigitalWallet>;
  /** Direction of money movement: Credit (money coming in) or Debit (money going out of the account) */
  direction: FundsFlowDirection;
  /** The merchant to which the transaction was made */
  merchant: Merchant;
  /** The payment method used, one of: Manual, Swipe, Contactless, ChipAndPin, Stored, Other. */
  paymentMethod?: Maybe<PaymentMethod>;
  /** Human-readable description of the transaction, typically including merchant name or transfer details */
  summary: Scalars['String'];
  /** The tags of a transaction */
  tags?: Maybe<TransactionTags>;
  /** The tax category of the transaction (actual or predicted). */
  taxCategory?: Maybe<Scalars['String']>;
  /** The title of the transaction */
  title: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /** Retrieves a specific bank account by its unique identifier. Used for fetching detailed account information including balance, status, and configuration. */
  accountById: Account;
  /** Retrieves a bank account by its designated purpose (Primary, Tax, Savings, etc.). Returns the first account found for the specified purpose type. */
  accountByPurpose: Account;
  /** Retrieves all card authorization requests for a specific account, including both approved and pending transactions. Used for monitoring card spending activity and transaction history. */
  authorizations: Array<Authorization>;
  /** Generates chart data for account balance analytics over time, including external account connections and balance trends. Used for financial dashboard visualizations showing account performance and balance history across different timeframes. */
  balanceDetails?: Maybe<Chart>;
  /** Retrieves all savings buckets for the customer with optional status filtering. Shows bucket balances, savings percentages, and configuration for managing automatic savings allocations. */
  buckets: Array<Bucket>;
  /** Retrieves all debit cards associated with the customer account, including both physical and virtual cards. Shows card status, expiration dates, and account associations for card management and spending control. */
  cards: Array<Card>;
  /** Generates comprehensive cashflow analysis for the specified time period, including income, expenses, savings, and net balance. Provides detailed breakdowns by source (client payments, ACH, cards) and category for financial planning and business insights. */
  cashflow: Cashflow;
  /** Retrieve a chart for cashflow data */
  cashflowChart?: Maybe<Chart>;
  /** Retrieves all saved payment recipients (counterparties) for the customer. Returns banking details, approval status, and relationship information for vendors, contractors, and service providers. Used for displaying payment recipient options and managing recurring payment setups. */
  counterparties: Array<AchCounterparty>;
  /** Retrieves all business relationship tags linking this customer to payment recipients. Shows organized categories of vendors, contractors, and service providers for payment management and financial reporting. */
  counterpartyRelationships: Array<Scalars['String']>;
  /** Create plaid link token */
  createLinkToken: Token;
  /** Create plaid link token for reconnect */
  createLinkTokenForReconnect: Token;
  /** Retrieves customer account information including business details, contact information, and account status. Can fetch by HoneyBook member ID or defaults to current session customer for account management and verification purposes. */
  customer?: Maybe<Customer>;
  /** Get all external accounts session customer. */
  externalAccounts: Array<ExternalAccount>;
  /** Retrieve financial connection accounts statuses associated with the company */
  financialConnections: FinancialConnections;
  /** Retrieves AI-powered financial insights and recommendations based on the customer's transaction patterns, spending habits, and business performance. Provides actionable advice for cash flow optimization, expense management, tax planning, and revenue growth. */
  financialInsights: Array<FinancialInsight>;
  /** Retrieves a specific card authorization by ID with detailed transaction information, merchant details, and approval status. Includes option to fetch non-authorized transactions for comprehensive spending analysis. */
  getAuthorization: Authorization;
  /** Get the payroll employer for the current user. Returns null if no employer exists. */
  getEmployer?: Maybe<Employer>;
  /** Checks for existing valid customer authentication tokens for a specific purpose to avoid redundant two-factor authentication. Returns masked token information if a valid token exists, or null if new authentication is required. */
  getExistingCustomerToken?: Maybe<CustomerToken>;
  /** Retrieves a paginated list of business expenses with optional filtering by date range, project, and pagination controls. Automatically adjusts time boundaries to include full days. */
  getExpenses: PaginatedExpensesResponse;
  /** Get the payroll subscription for the current user. */
  getPayrollSubscription?: Maybe<PayrollSubscription>;
  getTwoFactorState: TwoFactorState;
  /** Get all UI preferences. */
  getUIPreferences: Array<UiPreference>;
  /** Get a worker by id. */
  getWorker: Worker;
  /** Check if the current user has any expenses */
  hasExpenses: Scalars['Boolean'];
  /** Generates chart data for HoneyBook payment analytics showing paid, overdue, and upcoming payments over time. Returns datasets with payment amounts and counts categorized by status for revenue tracking and cash flow visualization. */
  hbPayments?: Maybe<Chart>;
  /** Get the HB subscription plan for the current user. (using the session) */
  hbSubscription?: Maybe<HbSubscription>;
  /** Get all workers. */
  listWorkers: Array<Worker>;
  /** Returns a list of month numbers (1-12) that contain transactions for the specified year. Used for building date navigation UI and showing periods with financial activity. */
  monthsWithTransactionsByYear: Array<Scalars['Float']>;
  /** Retrieves all pending ACH payments for the specified account. Shows payments that have been initiated but not yet completed, including their status and expected completion dates. */
  pendingPayments: Array<AchPayment>;
  /** Retrieves the previous year's revenue goal for historical comparison and year-over-year growth analysis. Used for setting realistic targets and measuring business growth trends. */
  previousYearlyRevenueGoal?: Maybe<YearlyRevenueGoal>;
  /** Fetch cashflow info for the given project */
  projectCashflow: ProjectCashflow;
  /** List all recurring ACH credit payments */
  recurringAchCreditPayments: Array<RecurringAchCreditPayment>;
  /** Retrieves all savings accounts for the customer, including both regular savings buckets and tax withholding accounts. Used for displaying available savings options in the UI. */
  savingAccounts: Array<Account>;
  /** Search for projects */
  search: Array<Project>;
  /** Check if the user is eligible for balance */
  shouldShowBalanceBanner: Scalars['Boolean'];
  /** Check if the user is eligible for capital and did not got a loan yet */
  shouldShowCapitalBanner: Scalars['Boolean'];
  /** Check if the user is eligible for instant deposit */
  shouldShowInstantDepositBanner: Scalars['Boolean'];
  /** statement document as html string. */
  statementHTMLById: Scalars['String'];
  /** statement document as pdf array buffer. */
  statementPDFById: Array<Scalars['Float']>;
  /** list of statement data. */
  statements: Array<Statement>;
  /** Provides AI-generated revenue goal recommendations based on historical performance, growth trends, and business patterns. Helps users set realistic and achievable annual targets. */
  targetSuggestion?: Maybe<YearlyRevenueGoalSuggestion>;
  /** Retrieves all available business expense tax categories for proper expense classification and tax deduction tracking. Used to populate dropdown menus and validate tax category assignments for expenses, transactions, and card authorizations. */
  taxCategories: Array<TaxCategoryEnum>;
  /** tax document url */
  taxDocumentUrl: Scalars['String'];
  /** tax document urls */
  taxDocumentUrls: Array<Scalars['String']>;
  /** list of tax documents */
  taxDocuments: Array<TaxDocument>;
  /** Retrieves a specific transaction by its unique identifier and associated account. Used for displaying detailed transaction information including amount, merchant, and metadata. */
  transaction: Transaction;
  /** Retrieves a filtered list of transactions from primary and legacy accounts with extensive filtering options. Supports exclusion of taxes, withholdings, and fees, plus date range, sorting, and tag-based filtering for comprehensive transaction analysis. */
  transactions: Array<Transaction>;
  /** Generates a CSV export of all transactions for the specified month and year. Includes comprehensive transaction data with project information and handles pagination automatically to export complete datasets for accounting and reporting purposes. */
  transactionsCSV: Scalars['String'];
  /** Generates a secure upload token for document submission during the application process. Used for uploading identity verification documents, business licenses, and other required KYC materials. */
  uploadToken: Scalars['String'];
  /** Retrieves the current year's revenue goal with progress tracking and status information. Used for displaying goal progress in dashboards and financial planning interfaces. */
  yearlyRevenueGoal?: Maybe<YearlyRevenueGoal>;
};


export type QueryAccountByIdArgs = {
  accountId: Scalars['ID'];
};


export type QueryAccountByPurposeArgs = {
  customerId?: InputMaybe<Scalars['ID']>;
  purpose: AccountPurposeEnum;
};


export type QueryAuthorizationsArgs = {
  accountId: Scalars['ID'];
};


export type QueryBalanceDetailsArgs = {
  since: Scalars['DateTime'];
  timeframeUnit: TimeframeUnit;
  timezone: Scalars['String'];
  type: Scalars['String'];
  until: Scalars['DateTime'];
};


export type QueryBucketsArgs = {
  bucketStatus?: InputMaybe<BucketStatus>;
  customerId?: InputMaybe<Scalars['ID']>;
};


export type QueryCashflowArgs = {
  since: Scalars['DateTime'];
  until: Scalars['DateTime'];
};


export type QueryCashflowChartArgs = {
  since: Scalars['Date'];
  timeframeUnit: TimeframeUnit;
  until: Scalars['Date'];
};


export type QueryCreateLinkTokenArgs = {
  plaidProducts: Array<Scalars['String']>;
};


export type QueryCreateLinkTokenForReconnectArgs = {
  institutionId: Scalars['String'];
};


export type QueryCustomerArgs = {
  hbId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetAuthorizationArgs = {
  authorizationId: Scalars['ID'];
  customerId?: InputMaybe<Scalars['ID']>;
  includeNonAuthorized: Scalars['Boolean'];
};


export type QueryGetExistingCustomerTokenArgs = {
  purpose: CustomerTokenPurpose;
};


export type QueryGetExpensesArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  mockData?: InputMaybe<Scalars['Boolean']>;
  page: Scalars['Int'];
  pageSize?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type QueryGetWorkerArgs = {
  workerId: Scalars['ID'];
};


export type QueryHbPaymentsArgs = {
  since: Scalars['Date'];
  timeframeUnit: TimeframeUnit;
  timezone: Scalars['String'];
  until: Scalars['Date'];
};


export type QueryMonthsWithTransactionsByYearArgs = {
  accountId: Scalars['ID'];
  direction?: InputMaybe<Array<Scalars['String']>>;
  excludeFees?: Scalars['Boolean'];
  excludeTaxes?: Scalars['Boolean'];
  excludeWithhold?: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  since?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<TransactionTagsInput>;
  type?: InputMaybe<Array<Scalars['String']>>;
  until?: InputMaybe<Scalars['String']>;
  year: Scalars['Float'];
};


export type QueryPendingPaymentsArgs = {
  accountId: Scalars['ID'];
};


export type QueryProjectCashflowArgs = {
  projectId: Scalars['String'];
};


export type QuerySearchArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  mockData?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
};


export type QueryStatementHtmlByIdArgs = {
  customerId?: InputMaybe<Scalars['ID']>;
  statementId: Scalars['ID'];
};


export type QueryStatementPdfByIdArgs = {
  customerId?: InputMaybe<Scalars['ID']>;
  statementId: Scalars['ID'];
};


export type QueryStatementsArgs = {
  accountId: Scalars['ID'];
  customerId?: InputMaybe<Scalars['ID']>;
};


export type QueryTaxDocumentUrlArgs = {
  documentId: Scalars['ID'];
};


export type QueryTaxDocumentUrlsArgs = {
  documentIds: Array<Scalars['ID']>;
};


export type QueryTransactionArgs = {
  accountId: Scalars['ID'];
  transactionId: Scalars['ID'];
};


export type QueryTransactionsArgs = {
  accountId: Scalars['ID'];
  direction?: InputMaybe<Array<Scalars['String']>>;
  excludeFees?: Scalars['Boolean'];
  excludeTaxes?: Scalars['Boolean'];
  excludeWithhold?: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  since?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<TransactionTagsInput>;
  type?: InputMaybe<Array<Scalars['String']>>;
  until?: InputMaybe<Scalars['String']>;
};


export type QueryTransactionsCsvArgs = {
  accountId: Scalars['ID'];
  direction?: InputMaybe<Array<Scalars['String']>>;
  excludeFees?: Scalars['Boolean'];
  excludeTaxes?: Scalars['Boolean'];
  excludeWithhold?: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  month: Scalars['Float'];
  since?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<TransactionTagsInput>;
  type?: InputMaybe<Array<Scalars['String']>>;
  until?: InputMaybe<Scalars['String']>;
  year: Scalars['Float'];
};

export type RecurringAchCreditPayment = {
  __typename?: 'RecurringAchCreditPayment';
  /** JSON object representing the payment resource. */
  attributes: RecurringCreditAchPaymentAttributes;
  /** Counterparty of the recurring payment */
  counterparty?: Maybe<Counterparty>;
  /** Identifier of the ACH payment resource. */
  id: Scalars['ID'];
  /** Is reccuring payment pending approval. */
  isPendingApproval: Scalars['Boolean'];
  /** Type of the payment resource. */
  type: Scalars['String'];
};

export type RecurringAchCreditPaymentInput = {
  /** Optional, additional payment description (maximum of 80 characters), not all institutions present that. */
  addenda?: InputMaybe<Scalars['String']>;
  /** The amount (cents) of the payment. */
  amount: Scalars['Int'];
  /** Counterparty ID. */
  counterpartyId: Scalars['String'];
  /** Payment description (maximum of 10 characters), also known as Company Entry Description, this will show up on statement of the counterparty. */
  description: Scalars['String'];
  /** The schedule of the recurring payment. */
  schedule: ScheduleInput;
};

export type RecurringCreditAchPaymentAttributes = {
  __typename?: 'RecurringCreditAchPaymentAttributes';
  /** Optional, additional payment description (maximum of 50 characters), not all institutions present that. */
  addenda?: Maybe<Scalars['String']>;
  /** The amount (cents) of the payment. */
  amount: Scalars['Int'];
  /** The date the resource was created. */
  createdAt: Scalars['DateTime'];
  /** Payment description (maximum of 10 characters), also known as Company Entry Description, this will show up on statement of the counterparty. */
  description: Scalars['String'];
  /** Represents the number of payments that were created by this recurring payment. */
  numberOfPayments: Scalars['Int'];
  /** The party on the other side of the ACH payment. */
  schedule: Schedule;
  /** One of Active, Completed, Disabled. */
  status: RecurringPaymentStatus;
  /** The date the resource was updated. */
  updatedAt: Scalars['DateTime'];
};

export enum RecurringPaymentStatus {
  Active = 'Active',
  Completed = 'Completed',
  Deleted = 'Deleted',
  Disabled = 'Disabled'
}

/** Input for removing business relationship tags between customer and payment recipients */
export type RemoveCounterypartyRelationshipsArgs = {
  /** Array of business relationship identifiers to unlink from this customer - used when ending vendor relationships or reorganizing categories */
  counterpartyRelationships: Array<Scalars['String']>;
  /** Optional customer identifier - defaults to current session customer if not provided */
  customerId?: InputMaybe<Scalars['ID']>;
};

export type ReportDownload = {
  __typename?: 'ReportDownload';
  /** The URI of the resource in S3. */
  uri: Scalars['String'];
};

export type ReportFiltersInput = {
  endDate: Scalars['String'];
  /** the file name of the generated report */
  fileName?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
  timezone: Scalars['String'];
  /** The type of report. */
  type: ReportType;
};

/** The type of report. */
export enum ReportType {
  AllTaxReports = 'ALL_TAX_REPORTS',
  Capital = 'CAPITAL',
  Discounts = 'DISCOUNTS',
  Expenses = 'EXPENSES',
  FeesCharged = 'FEES_CHARGED',
  PaymentsCompleted = 'PAYMENTS_COMPLETED',
  PaymentsProcessedDetailed = 'PAYMENTS_PROCESSED_DETAILED',
  PaymentsProcessedSummary = 'PAYMENTS_PROCESSED_SUMMARY',
  PayrollReport = 'PAYROLL_REPORT',
  Refunds = 'REFUNDS',
  SalesTax = 'SALES_TAX'
}

export type SaveUiPreferenceInput = {
  /** The key of the preference. */
  key: Scalars['String'];
  /** The value of the preference. */
  value: Scalars['JSONObject'];
};

/** Breakdown of automatic savings showing money set aside through bucket withholding during the selected time period */
export type SavingsDetails = {
  __typename?: 'SavingsDetails';
  /** Total amount in cents automatically withheld to all non-tax savings buckets (emergency fund, equipment fund, etc.) */
  bucketsSavings: Scalars['Float'];
  /** Total amount in cents automatically withheld to the tax savings bucket for estimated tax payments */
  taxSavings: Scalars['Float'];
};

export type Schedule = {
  __typename?: 'Schedule';
  /** Required if interval is Monthly. Scheduled day time in the month. Valid values can be between 1-28 or (-5)-(-1). Negative numbers represent relative day to the end of the month. -1 represents the last day of the month. */
  dayOfMonth?: Maybe<Scalars['Float']>;
  /** Required if interval is Monthly. Required when Weekly interval is specified. Valid values are Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday. */
  dayOfWeek?: Maybe<Scalars['String']>;
  /** RFC3339 format. For more information: https://en.wikipedia.org/wiki/ISO_8601#RFCs End time of the recurring payment. Date only (e.g. "2022-10-29 ") */
  endTime?: Maybe<Scalars['Date']>;
  /** Interval of the schedule. Can be Monthly. */
  interval: Interval;
  /** RFC3339 format. For more information: https://en.wikipedia.org/wiki/ISO_8601#RFCs The next scheduled date of the action. */
  nextScheduledAction?: Maybe<Scalars['String']>;
  /** RFC3339 format. For more information: https://en.wikipedia.org/wiki/ISO_8601#RFCs Start time of the recurring payment. Date only (e.g. "2022-06-29") */
  startTime?: Maybe<Scalars['Date']>;
  /** Optional. Total number of payment repetitions. Positive integers only. */
  totalNumberOfPayments?: Maybe<Scalars['Float']>;
};

export type ScheduleInput = {
  /** Required if interval is Monthly. Scheduled day time in the month. Valid values can be between 1-28 or (-5)-(-1). Negative numbers represent relative day to the end of the month. -1 represents the last day of the month. */
  dayOfMonth?: InputMaybe<Scalars['Float']>;
  /** Required if interval is Weekly. Required when Weekly interval is specified. Valid values are Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday. */
  dayOfWeek?: InputMaybe<DayOfWeek>;
  /** RFC3339 format. For more information: https://en.wikipedia.org/wiki/ISO_8601#RFCs End time of the recurring payment. Date only (e.g. "2022-10-29 ") */
  endTime?: InputMaybe<Scalars['Date']>;
  /** Interval of the schedule. Can be Monthly. */
  interval: Interval;
  /** RFC3339 format. For more information: https://en.wikipedia.org/wiki/ISO_8601#RFCs Start time of the recurring payment. Date only (e.g. "2022-06-29") */
  startTime?: InputMaybe<Scalars['Date']>;
};

export type Statement = {
  __typename?: 'Statement';
  /** JSON object representing the statement data. */
  attributes: StatementAttributes;
  /** Identifier of the statement resource. */
  id: Scalars['ID'];
  /** Type of the statement resource. */
  type: Scalars['String'];
};

export type StatementAttributes = {
  __typename?: 'StatementAttributes';
  /** Period of the statement, formatted YYYY-MM. */
  period: Scalars['String'];
};

export type SubscriptionPaymentMethod = {
  __typename?: 'SubscriptionPaymentMethod';
  cardType: Scalars['String'];
  firstName: Scalars['String'];
  lastFour: Scalars['String'];
  lastName: Scalars['String'];
};

/** The subscription plan for the user. */
export enum SubscriptionPlan {
  Essentials = 'essentials',
  Premium = 'premium',
  Starter = 'starter'
}

/** The subscription state for the user (active, trialer etc). */
export enum SubscriptionState {
  Active = 'active',
  ExTrialer = 'ex_trialer',
  Subscribed = 'subscribed',
  Trialer = 'trialer'
}

/** Tax categories for business expenses and income classification. Used for tax reporting and deduction calculations. Categories include business expenses like office supplies, travel, meals, advertising, and various income types. */
export enum TaxCategoryEnum {
  AdvertisingAndMarketing = 'AdvertisingAndMarketing',
  BankAndTransactionFees = 'BankAndTransactionFees',
  CharitableContribution = 'CharitableContribution',
  ClientGifts = 'ClientGifts',
  CommissionAndFees = 'CommissionAndFees',
  ContinuingEducationAndTraining = 'ContinuingEducationAndTraining',
  ContractLabor = 'ContractLabor',
  CostsOfGoodsSold = 'CostsOfGoodsSold',
  GasAndFuel = 'GasAndFuel',
  HomeOfficeExpenses = 'HomeOfficeExpenses',
  Insurance = 'Insurance',
  Interest = 'Interest',
  LegalAndProfessionalServices = 'LegalAndProfessionalServices',
  Licenses = 'Licenses',
  MealsWithClients = 'MealsWithClients',
  OfficeExpenses = 'OfficeExpenses',
  OfficeSupplies = 'OfficeSupplies',
  PayrollTaxes = 'PayrollTaxes',
  PayrollWages = 'PayrollWages',
  Personal = 'Personal',
  Rent = 'Rent',
  ShippingAndPostage = 'ShippingAndPostage',
  Supplies = 'Supplies',
  TollsAndParking = 'TollsAndParking',
  TravelAirfare = 'TravelAirfare',
  TravelLodging = 'TravelLodging',
  TravelMeals = 'TravelMeals',
  Utilities = 'Utilities'
}

export type TaxDocument = {
  __typename?: 'TaxDocument';
  /** Identifier for the tax document. */
  id: Scalars['String'];
  /** Document name. */
  name: Scalars['String'];
  /** Document status. */
  status: Scalars['String'];
  /** Type of the tax document (e.g., '1099-K', '1099-NEC'). */
  type: Scalars['String'];
  /** Tax year. */
  year: Scalars['Float'];
};

/** Time granularity for chart data aggregation: Day (daily data points), Week (weekly summaries), Month (monthly totals), Year (yearly aggregates). Determines how data is grouped and displayed on charts. */
export enum TimeframeUnit {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export type ToggleRecurringPaymentStatusInput = {
  /** The status of the recurring payment. */
  active: Scalars['Boolean'];
  /** Recurring payment id. */
  recurringPaymentId: Scalars['ID'];
};

export type Token = {
  __typename?: 'Token';
  /** token */
  token: Scalars['String'];
};

/** Base transaction interface that all transaction types implement. Transactions represent money movements in and out of accounts. */
export type Transaction = {
  /** Resolves the bank account identifier associated with this transaction, used for linking transactions to specific accounts and account-based filtering */
  accountId: Scalars['String'];
  /** The expected completion date of the transaction */
  expectedCompletionDate?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this transaction in the financial system */
  id: Scalars['ID'];
  /** Resolves the HoneyBook project associated with this transaction for client billing and project cost tracking. Returns null if no project is linked or if project data cannot be retrieved. */
  project?: Maybe<Project>;
  /** The recurring payment ID connected to this transaction */
  recurringPaymentId?: Maybe<Scalars['String']>;
  /** Transaction type indicating the method of payment (e.g., "purchase" for card transactions, "originatedAch" for ACH transfers) */
  type: Scalars['String'];
  /** Resolves all automatic savings bucket withholdings made from this transaction, showing how money was distributed to tax and other savings buckets. Used for displaying savings allocation details. */
  withholdings?: Maybe<Array<BucketWithhold>>;
};

/** Core transaction data including amount, direction, balance impact, and metadata */
export type TransactionAttributes = {
  __typename?: 'TransactionAttributes';
  /** Transaction amount in cents (e.g., $12.34 = 1234 cents). Always positive regardless of direction. */
  amount: Scalars['Int'];
  /** Account balance in cents immediately after this transaction was processed */
  balance: Scalars['Int'];
  /** The category of the transaction */
  category?: Maybe<Scalars['String']>;
  /** Timestamp when the transaction was created or processed by the financial institution */
  createdAt: Scalars['DateTime'];
  /** Direction of money movement: Credit (money coming in) or Debit (money going out of the account) */
  direction: FundsFlowDirection;
  /** Human-readable description of the transaction, typically including merchant name or transfer details */
  summary: Scalars['String'];
  /** Additional metadata including tax categorization, project association, and bucket withholding information */
  tags?: Maybe<TransactionTags>;
  /** The tax category of the transaction (actual or predicted). */
  taxCategory?: Maybe<Scalars['String']>;
  /** The title of the transaction */
  title: Scalars['String'];
};

/** Metadata and categorization information attached to a transaction */
export type TransactionTags = {
  __typename?: 'TransactionTags';
  /** Visual icon identifier for the bucket that received funds (only populated for bucket withholding transactions) */
  bucketIcon?: Maybe<Scalars['String']>;
  /** Name of the specific bucket that received withheld funds (only populated for bucket withholding transactions) */
  bucketName?: Maybe<Scalars['String']>;
  /** Email address of the person or business involved in the transaction (when available) */
  counterpartyEmail?: Maybe<Scalars['String']>;
  /** Business relationship between the customer and the other party (e.g., "client", "vendor", "contractor", "employee") */
  counterpartyRelationship?: Maybe<Scalars['String']>;
  /** Total amount in cents withheld to all non-tax savings buckets (emergency fund, equipment fund, etc.) */
  otherBucketsWithholdAmount?: Maybe<Scalars['String']>;
  /** AI-suggested tax category based on merchant, amount, and transaction patterns - user can accept or override this suggestion */
  predictedTaxCategory?: Maybe<Scalars['String']>;
  /** HoneyBook project identifier if this transaction is associated with a specific client project or contract */
  projectId?: Maybe<Scalars['String']>;
  /** Business purpose or category of the transaction (e.g., "office supplies", "client payment", "travel expense") */
  purpose?: Maybe<Scalars['String']>;
  /** Manually assigned tax category for business expense/income classification and tax reporting */
  taxCategory?: Maybe<Scalars['String']>;
  /** Amount in cents automatically withheld to the tax savings bucket for this transaction */
  taxWithholdAmount?: Maybe<Scalars['String']>;
  /** Withholding percentage used for this bucket (only populated for bucket withholding transactions) */
  withholdPercentage?: Maybe<Scalars['String']>;
};

/** Transaction metadata tags for categorization, project tracking, and tax reporting */
export type TransactionTagsInput = {
  /** Business category tag for expense classification (e.g., "office_supplies", "travel", "meals") */
  category?: InputMaybe<Scalars['String']>;
  /** HoneyBook project identifier to associate this transaction with a specific client project for cost tracking */
  projectId?: InputMaybe<Scalars['String']>;
  /** Tax category for business expense/income classification used in tax reporting and deduction calculations */
  taxCategory?: InputMaybe<Scalars['String']>;
};

/** TwoFactor state of a user */
export type TwoFactorState = {
  __typename?: 'TwoFactorState';
  lastTwoFactorTime?: Maybe<Scalars['Date']>;
  twoFactorEnabled: Scalars['Boolean'];
};

export type UiPreference = {
  __typename?: 'UIPreference';
  /** The key of the preference. */
  key: Scalars['String'];
  /** The value of the preference. */
  value: Scalars['JSONObject'];
};

/** Communication channel for sending two-factor authentication codes: SMS (text message) or Call (voice call) for customer verification */
export enum UnitVerificationTokenChannel {
  Call = 'CALL',
  Sms = 'SMS'
}

/** Account attributes container for update operations */
export type UpdateAccountAttributes = {
  /** Account metadata including tax withholding configuration */
  tags: UpdateAccountTags;
};

/** Complete input for updating account configuration and settings */
export type UpdateAccountInput = {
  /** Unique identifier of the account to update */
  accountId: Scalars['ID'];
  /** Account attributes to update, including tax withholding settings */
  attributes: UpdateAccountAttributes;
};

/** Account metadata that can be updated, primarily tax withholding settings */
export type UpdateAccountTags = {
  /** Tax withholding percentage for automatic savings: undefined (no withholding), "smart" (AI-calculated rate), or decimal value between 0 and 1 (e.g., "0.25" for 25%) */
  taxWithholdingPercentage?: InputMaybe<Scalars['String']>;
};

/** Input for updating existing payment recipient metadata and categorization */
export type UpdateAchCounterypartyArgs = {
  /** Unique identifier of the saved payment recipient to update */
  counterpartyId: Scalars['ID'];
  /** Updated metadata tags including relationship type and contact information */
  tags: CounterpartyTagsInput;
};

/** Input data for updating an existing business expense with partial field updates */
export type UpdateExpenseInput = {
  /** Updated expense amount in cents - only provide if changing the amount */
  amount?: InputMaybe<Scalars['Float']>;
  /** Updated expense date - only provide if changing when the expense occurred */
  date?: InputMaybe<Scalars['Date']>;
  /** Unique identifier of the expense record to update */
  id: Scalars['ID'];
  /** Updated merchant or business name - only provide if changing the merchant */
  merchant?: InputMaybe<Scalars['String']>;
  /** Updated notes or description - only provide if changing the expense context */
  notes?: InputMaybe<Scalars['String']>;
  /** Updated HoneyBook project ID - only provide if changing project allocation */
  projectId?: InputMaybe<Scalars['String']>;
  /** Updated tax classification - only provide if changing the tax category */
  taxCategory?: InputMaybe<TaxCategoryEnum>;
};

/** Input for updating an existing yearly revenue goal target based on changing business conditions */
export type UpdateGoalInput = {
  /** Unique identifier of the revenue goal to update */
  id: Scalars['ID'];
  /** New target annual revenue amount in dollars to replace the existing goal */
  target: Scalars['Float'];
};

/** Input for updating transaction metadata including tax categories and project assignments */
export type UpdateTransactionInput = {
  /** Account identifier that contains the transaction being updated */
  accountId: Scalars['ID'];
  /** Updated transaction tags including category, project assignment, and tax classification */
  tags: TransactionTagsInput;
  /** Unique identifier of the transaction to update */
  transactionId: Scalars['ID'];
};

export type Worker = {
  __typename?: 'Worker';
  /** Email address of the worker. */
  email?: Maybe<Scalars['String']>;
  /** Identifier of the worker. */
  id: Scalars['ID'];
  /** Name of the worker. */
  name: Scalars['String'];
  /** Projects associated with the worker. */
  projects?: Maybe<Array<Project>>;
  /** Number of projects associated with the worker. */
  projectsCount?: Maybe<Scalars['Float']>;
  /** Current status of the worker. */
  status: WorkerStatus;
};

/** The status of a worker */
export enum WorkerStatus {
  NotReady = 'NOT_READY',
  Onboarding = 'ONBOARDING',
  PartiallyReady = 'PARTIALLY_READY',
  Ready = 'READY'
}

/** Annual revenue goal for tracking business income targets. Helps users set and monitor yearly earnings objectives based on client payments and other income sources. */
export type YearlyRevenueGoal = Goal & {
  __typename?: 'YearlyRevenueGoal';
  /** Calculates the actual revenue earned year-to-date toward the annual goal. Returns the dollar amount of progress made based on client payments and other income sources. */
  currentProgress: Scalars['Float'];
  /** End date of the goal tracking period in ISO format (e.g., "2024-12-31") */
  endDate: Scalars['Date'];
  /** Unique identifier for this goal in the system */
  id: Scalars['ID'];
  /** Calculates the completion percentage of the revenue goal based on current year-to-date earnings. Returns the percentage rounded down to a whole number (so 99.9% reports as 99) for progress visualization and performance tracking. */
  progressPercentage: Scalars['Float'];
  /** Human-readable text indicating when the data was last refreshed. */
  refreshTimestampHumanized?: Maybe<Scalars['String']>;
  /** Start date of the goal tracking period in ISO format (e.g., "2024-01-01") */
  startDate: Scalars['Date'];
  /** Determines the current achievement status of the revenue goal: IN_PROGRESS (actively working toward target), ACHIEVED (target reached), NOT_ACHIEVED (target not met by end date), or NOT_SET (no goal configured). */
  status: GoalStatus;
  /** Target amount to achieve for this goal (e.g., $50,000 annual revenue = 50000.00) */
  target: Scalars['Float'];
  /** HoneyBook user ID of the person who set this goal */
  userId: Scalars['ID'];
};

/** AI-generated suggestion for setting a yearly revenue goal based on historical performance and growth patterns */
export type YearlyRevenueGoalSuggestion = {
  __typename?: 'YearlyRevenueGoalSuggestion';
  /** Total revenue earned in the previous year, used as baseline for calculating the suggested target */
  previousYearRevenue: Scalars['Float'];
  /** Recommended target revenue amount for the upcoming year based on previous performance and growth trends */
  target: Scalars['Float'];
};

export type CashflowQueryVariables = Exact<{
  since: Scalars['DateTime'];
  until: Scalars['DateTime'];
}>;


export type CashflowQuery = { __typename?: 'Query', cashflow: { __typename?: 'Cashflow', income: number, expenses: number, balance: number, savings: number, incomeDetails: { __typename?: 'IncomeDetails', clientPayments: number, receivedAchTransaction: number, miscellaneous: number }, expenseDetails: { __typename?: 'ExpenseDetails', cardTransaction: number, achTransaction: number, achPayment: number, atmTransaction: number, miscellaneous: number }, savingsDetails: { __typename?: 'SavingsDetails', taxSavings: number, bucketsSavings: number } } };

export type FinancialInsightsQueryVariables = Exact<{ [key: string]: never; }>;


export type FinancialInsightsQuery = { __typename?: 'Query', financialInsights: Array<{ __typename?: 'FinancialInsight', id: string, title: string, friendlyInsight: string, description: string, recommendation: string, createdAt: any, reaction: InsightReaction, rationale: Array<string>, type: InsightType }> };

export type SavingAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type SavingAccountsQuery = { __typename?: 'Query', savingAccounts: Array<{ __typename?: 'Account', id: string, type: string, attributes: { __typename?: 'AccountAttributes', accountNumber: string, balance: number } }> };

export type SetupAccountsMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupAccountsMutation = { __typename?: 'Mutation', setupAccounts: Array<{ __typename?: 'Account', id: string, type: string, attributes: { __typename?: 'AccountAttributes', accountNumber: string, balance: number } }> };

export type GetTwoFactorStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTwoFactorStateQuery = { __typename?: 'Query', getTwoFactorState: { __typename?: 'TwoFactorState', twoFactorEnabled: boolean } };

export type CreateYearlyRevenueGoalMutationVariables = Exact<{
  data: GoalInput;
}>;


export type CreateYearlyRevenueGoalMutation = { __typename?: 'Mutation', createYearlyRevenueGoal: { __typename?: 'YearlyRevenueGoal', id: string, target: number, startDate: any, endDate: any, status: GoalStatus, currentProgress: number, progressPercentage: number, refreshTimestampHumanized?: string | null } };

export type DeleteYearlyRevenueGoalMutationVariables = Exact<{
  data: DeleteGoalInput;
}>;


export type DeleteYearlyRevenueGoalMutation = { __typename?: 'Mutation', deleteYearlyRevenueGoal: boolean };

export type EditYearlyRevenueGoalMutationVariables = Exact<{
  data: UpdateGoalInput;
}>;


export type EditYearlyRevenueGoalMutation = { __typename?: 'Mutation', updateYearlyRevenueGoal: { __typename?: 'YearlyRevenueGoal', id: string, target: number, startDate: any, endDate: any, status: GoalStatus, currentProgress: number, progressPercentage: number } };

export type YearlyRevenueGoalQueryVariables = Exact<{ [key: string]: never; }>;


export type YearlyRevenueGoalQuery = { __typename?: 'Query', yearlyRevenueGoal?: { __typename?: 'YearlyRevenueGoal', id: string, target: number, startDate: any, endDate: any, status: GoalStatus, currentProgress: number, progressPercentage: number, refreshTimestampHumanized?: string | null } | null };

export type PreviousYearlyRevenueGoalQueryVariables = Exact<{ [key: string]: never; }>;


export type PreviousYearlyRevenueGoalQuery = { __typename?: 'Query', previousYearlyRevenueGoal?: { __typename?: 'YearlyRevenueGoal', id: string, target: number, startDate: any, endDate: any, status: GoalStatus, currentProgress: number, progressPercentage: number } | null };

export type SetYearlyRevenueGoalMutationVariables = Exact<{
  data: GoalInput;
}>;


export type SetYearlyRevenueGoalMutation = { __typename?: 'Mutation', setYearlyRevenueGoal: { __typename?: 'YearlyRevenueGoal', id: string, target: number, startDate: any, endDate: any, status: GoalStatus, currentProgress: number, progressPercentage: number, refreshTimestampHumanized?: string | null } };

export type YearlyRevenueGoalSuggestionQueryVariables = Exact<{ [key: string]: never; }>;


export type YearlyRevenueGoalSuggestionQuery = { __typename?: 'Query', targetSuggestion?: { __typename?: 'YearlyRevenueGoalSuggestion', target: number, previousYearRevenue: number } | null };

export type GetUploadTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUploadTokenQuery = { __typename?: 'Query', uploadToken: string };

export type AccountNumberQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type AccountNumberQuery = { __typename?: 'Query', accountById: { __typename?: 'Account', attributes: { __typename?: 'AccountAttributes', accountNumber: string } } };

export type AccountBalanceQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type AccountBalanceQuery = { __typename?: 'Query', accountById: { __typename?: 'Account', attributes: { __typename?: 'AccountAttributes', available: number } } };

export type SavingAccountsBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type SavingAccountsBalanceQuery = { __typename?: 'Query', savingAccounts: Array<{ __typename?: 'Account', id: string, attributes: { __typename?: 'AccountAttributes', balance: number } }> };

export type BucketsQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
  bucketStatus?: InputMaybe<BucketStatus>;
}>;


export type BucketsQuery = { __typename?: 'Query', buckets: Array<{ __typename?: 'Bucket', id: string, isTaxBucket: boolean, savings: number, name: string, savingsPercentage: string, icon: string, legacySmartTaxRate?: string | null }> };

export type UpdateBucketMutationVariables = Exact<{
  bucketId: Scalars['String'];
  savingsPercentage?: InputMaybe<Scalars['String']>;
}>;


export type UpdateBucketMutation = { __typename?: 'Mutation', updateBucket: { __typename?: 'Bucket', id: string, savings: number, name: string, savingsPercentage: string, isTaxBucket: boolean, icon: string } };

export type UpdateGenericBucketMutationVariables = Exact<{
  bucketId: Scalars['String'];
  savingsPercentage?: InputMaybe<Scalars['String']>;
  bucketName?: InputMaybe<Scalars['String']>;
  bucketIcon?: InputMaybe<Scalars['String']>;
}>;


export type UpdateGenericBucketMutation = { __typename?: 'Mutation', updateBucket: { __typename?: 'Bucket', id: string, savings: number, name: string, savingsPercentage: string, isTaxBucket: boolean, icon: string } };

export type CloseBucketMutationVariables = Exact<{
  transferBalance?: InputMaybe<Scalars['Boolean']>;
  bucketId: Scalars['String'];
}>;


export type CloseBucketMutation = { __typename?: 'Mutation', closeBucket: { __typename?: 'Account', id: string } };

export type CreateSavingsBucketMutationVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
  bucketName: Scalars['String'];
  bucketSavingsPercentage: Scalars['String'];
  isTaxBucket: Scalars['Boolean'];
  bucketIcon: Scalars['String'];
}>;


export type CreateSavingsBucketMutation = { __typename?: 'Mutation', createSavingsBucket: { __typename?: 'Bucket', id: string, savings: number, name: string, savingsPercentage: string, isTaxBucket: boolean } };

export type TransferBucketBalanceMutationVariables = Exact<{
  bucketId: Scalars['String'];
}>;


export type TransferBucketBalanceMutation = { __typename?: 'Mutation', transferBucketBalance: { __typename?: 'Bucket', id: string, savings: number, name: string, savingsPercentage: string, isTaxBucket: boolean } };

export type TransferFromBucketBalanceMutationVariables = Exact<{
  bucketId: Scalars['String'];
  amount?: InputMaybe<Scalars['Float']>;
}>;


export type TransferFromBucketBalanceMutation = { __typename?: 'Mutation', transferFromBucketBalance: { __typename?: 'Bucket', id: string, savings: number, name: string, savingsPercentage: string, isTaxBucket: boolean } };

export type TransferToBucketBalanceMutationVariables = Exact<{
  bucketId: Scalars['String'];
  amount?: InputMaybe<Scalars['Float']>;
}>;


export type TransferToBucketBalanceMutation = { __typename?: 'Mutation', transferToBucketBalance: { __typename?: 'Bucket', id: string, savings: number, name: string, savingsPercentage: string, isTaxBucket: boolean } };

export type HbSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type HbSubscriptionQuery = { __typename?: 'Query', hbSubscription?: { __typename?: 'HBSubscription', paymentMethod?: { __typename?: 'SubscriptionPaymentMethod', lastFour: string } | null } | null };

export type CreateDebitCardMutationVariables = Exact<{
  data: DebitCardInput;
}>;


export type CreateDebitCardMutation = { __typename?: 'Mutation', createDebitCard: { __typename?: 'BusinessDebitCard', id: string } | { __typename?: 'BusinessVirtualDebitCard', id: string } | { __typename?: 'IndividualDebitCard', id: string } | { __typename?: 'IndividualVirtualDebitCard', id: string } };

export type StatementsQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
  accountId: Scalars['ID'];
}>;


export type StatementsQuery = { __typename?: 'Query', statements: Array<{ __typename?: 'Statement', id: string, attributes: { __typename?: 'StatementAttributes', period: string } }> };

export type GetMonthsWithTransactionsByYearQueryVariables = Exact<{
  accountId: Scalars['ID'];
  year: Scalars['Float'];
}>;


export type GetMonthsWithTransactionsByYearQuery = { __typename?: 'Query', monthsWithTransactionsByYear: Array<number> };

export type FirstTransactionQueryVariables = Exact<{
  accountId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type FirstTransactionQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'AchTransaction', attributes: { __typename?: 'AchTransactionAttributes', createdAt: any } } | { __typename?: 'BaseTransaction', attributes: { __typename?: 'TransactionAttributes', createdAt: any } } | { __typename?: 'PurchaseTransaction', attributes: { __typename?: 'PurchaseTransactionAttributes', createdAt: any } }> };

export type GetTransactionsCsvQueryVariables = Exact<{
  accountId: Scalars['ID'];
  month: Scalars['Float'];
  year: Scalars['Float'];
}>;


export type GetTransactionsCsvQuery = { __typename?: 'Query', transactionsCSV: string };

export type GetStatementPdfByIdQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
  statementId: Scalars['ID'];
}>;


export type GetStatementPdfByIdQuery = { __typename?: 'Query', statementPDFById: Array<number> };

export type GetStatementHtmlByIdQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
  statementId: Scalars['ID'];
}>;


export type GetStatementHtmlByIdQuery = { __typename?: 'Query', statementHTMLById: string };

export type FirstTransactionYearQueryVariables = Exact<{
  accountId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type FirstTransactionYearQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'AchTransaction', attributes: { __typename?: 'AchTransactionAttributes', createdAt: any } } | { __typename?: 'BaseTransaction', attributes: { __typename?: 'TransactionAttributes', createdAt: any } } | { __typename?: 'PurchaseTransaction', attributes: { __typename?: 'PurchaseTransactionAttributes', createdAt: any } }> };

export type AccountTaxWithholdingTagQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type AccountTaxWithholdingTagQuery = { __typename?: 'Query', accountById: { __typename?: 'Account', attributes: { __typename?: 'AccountAttributes', status: AccountStatusEnum, tags: { __typename?: 'AccountTags', taxWithholdingPercentage?: string | null } } } };

export type UpdateAccountMutationVariables = Exact<{
  data: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', attributes: { __typename?: 'AccountAttributes', tags: { __typename?: 'AccountTags', taxWithholdingPercentage?: string | null } } } };

export type CreateBookPaymentMutationVariables = Exact<{
  data: CreateBookPaymentInput;
}>;


export type CreateBookPaymentMutation = { __typename?: 'Mutation', createBookPayment: { __typename?: 'AchPayment', attributes: { __typename?: 'AchPaymentAttributes', status: PaymentStatus, amount?: number | null, description: string } } };

export type ListExpensesQueryVariables = Exact<{
  accountId: Scalars['ID'];
  since?: InputMaybe<Scalars['String']>;
}>;


export type ListExpensesQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'AchTransaction', id: string, attributes: { __typename?: 'AchTransactionAttributes', amount: number, category?: string | null } } | { __typename?: 'BaseTransaction', id: string, attributes: { __typename?: 'TransactionAttributes', amount: number, category?: string | null } } | { __typename?: 'PurchaseTransaction', id: string, attributes: { __typename?: 'PurchaseTransactionAttributes', amount: number, category?: string | null } }> };

export type HasExpensesQueryVariables = Exact<{ [key: string]: never; }>;


export type HasExpensesQuery = { __typename?: 'Query', hasExpenses: boolean };

export type DeleteExpenseMutationVariables = Exact<{
  data: DeleteExpenseInput;
}>;


export type DeleteExpenseMutation = { __typename?: 'Mutation', deleteExpense: boolean };

export type CreateNewExpenseMutationVariables = Exact<{
  input: CreateExpenseInput;
}>;


export type CreateNewExpenseMutation = { __typename?: 'Mutation', createExpense: { __typename?: 'Expense', id: string, amount: number, date: any, merchant: string, notes?: string | null, taxCategory?: TaxCategoryEnum | null, project?: { __typename?: 'Project', id: string, name: string, isDeleted?: boolean | null, workspaceId?: string | null } | null, source?: { __typename?: 'ExpenseSourceDetails', name: string, last4: string, id: string } | null } };

export type UpdateExpenseMutationVariables = Exact<{
  data: UpdateExpenseInput;
}>;


export type UpdateExpenseMutation = { __typename?: 'Mutation', updateExpense: { __typename?: 'Expense', id: string, amount: number, date: any, merchant: string, notes?: string | null, taxCategory?: TaxCategoryEnum | null, project?: { __typename?: 'Project', id: string, name: string, isDeleted?: boolean | null, workspaceId?: string | null } | null, source?: { __typename?: 'ExpenseSourceDetails', name: string, last4: string, id: string } | null } };

export type GenerateExpenseReportMutationVariables = Exact<{
  filters: ReportFiltersInput;
}>;


export type GenerateExpenseReportMutation = { __typename?: 'Mutation', generateReport: { __typename?: 'ReportDownload', uri: string } };

export type GetFinancialConnectionsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancialConnectionsStatusQuery = { __typename?: 'Query', hbSubscription?: { __typename?: 'HBSubscription', plan?: SubscriptionPlan | null, state?: SubscriptionState | null } | null, financialConnections: { __typename?: 'FinancialConnections', connections: Array<{ __typename?: 'FinancialConnection', reason?: string | null, status: FinancialConnectionStatus, id: string, createdAt: string }> } };

export type GetFinancialConnectionsAuthTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancialConnectionsAuthTokenQuery = { __typename?: 'Query', financialConnections: { __typename?: 'FinancialConnections', authToken: string } };

export type ConnectFinancialAccountsMutationVariables = Exact<{
  data: ConnectFinancialAccountsInput;
}>;


export type ConnectFinancialAccountsMutation = { __typename?: 'Mutation', connectFinancialAccounts: boolean };

export type DisconnectFinancialConnectionMutationVariables = Exact<{
  connectionId: Scalars['String'];
}>;


export type DisconnectFinancialConnectionMutation = { __typename?: 'Mutation', disconnectFinancialConnection: boolean };

export type ShouldShowCapitalBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type ShouldShowCapitalBannerQuery = { __typename?: 'Query', shouldShowCapitalBanner: boolean };

export type ShouldShowInstantDepositBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type ShouldShowInstantDepositBannerQuery = { __typename?: 'Query', shouldShowInstantDepositBanner: boolean };

export type ShouldShowBalanceBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type ShouldShowBalanceBannerQuery = { __typename?: 'Query', shouldShowBalanceBanner: boolean };

export type CreateBusinessApplicationMutationVariables = Exact<{
  data: BusinessApplicationInput;
}>;


export type CreateBusinessApplicationMutation = { __typename?: 'Mutation', businessApplication: { __typename?: 'BusinessApplication', id: string, attributes: { __typename?: 'BusinessApplicationAttributes', status: ApplicationStatus } } };

export type CreateIndividualApplicationMutationVariables = Exact<{
  data: IndividualApplicationInput;
}>;


export type CreateIndividualApplicationMutation = { __typename?: 'Mutation', individualApplication: { __typename?: 'IndividualApplication', id: string, attributes: { __typename?: 'IndividualApplicationAttributes', status: ApplicationStatus } } };

export type AddWorkerToProjectMutationVariables = Exact<{
  workerId: Scalars['ID'];
  projectId: Scalars['ID'];
}>;


export type AddWorkerToProjectMutation = { __typename?: 'Mutation', addWorkerToProject: boolean };

export type RemoveWorkerFromProjectMutationVariables = Exact<{
  workerId: Scalars['ID'];
  projectId: Scalars['ID'];
}>;


export type RemoveWorkerFromProjectMutation = { __typename?: 'Mutation', removeWorkerFromProject: boolean };

export type CreatePayrollEmployerMutationVariables = Exact<{
  payrollType: PayrollType;
}>;


export type CreatePayrollEmployerMutation = { __typename?: 'Mutation', createNewPayrollEmployer: { __typename?: 'Employer', id: string, externalId: string, employerAccountStatus: EmployerAccountStatus, payrollType: PayrollType } };

export type CreateEmployerUserTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateEmployerUserTokenMutation = { __typename?: 'Mutation', createEmployerUserToken: { __typename?: 'EmployerToken', token: string, expiration: any } };

export type DeleteWorkerMutationVariables = Exact<{
  workerId: Scalars['ID'];
}>;


export type DeleteWorkerMutation = { __typename?: 'Mutation', deleteWorker: { __typename?: 'DeleteWorkerResponse', success: boolean, errorMessage?: string | null } };

export type GetPayrollWorkerProjectsQueryVariables = Exact<{
  workerId: Scalars['ID'];
}>;


export type GetPayrollWorkerProjectsQuery = { __typename?: 'Query', getWorker: { __typename: 'Worker', projects?: Array<{ __typename?: 'Project', id: string, name: string, stage?: string | null, imageUrl?: string | null, workspaceId?: string | null }> | null } };

export type ListWorkersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListWorkersQuery = { __typename?: 'Query', listWorkers: Array<{ __typename?: 'Worker', id: string, name: string, email?: string | null, status: WorkerStatus, projectsCount?: number | null }> };

export type GetPayrollSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayrollSubscriptionQuery = { __typename?: 'Query', getPayrollSubscription?: { __typename?: 'PayrollSubscription', subscribed: boolean, account_id: string } | null };

export type UpdatePayrollSubscriptionMutationVariables = Exact<{
  subscribe: Scalars['Boolean'];
}>;


export type UpdatePayrollSubscriptionMutation = { __typename?: 'Mutation', updatePayrollSubscription: boolean };

export type CreateLinkTokenQueryVariables = Exact<{
  plaidProducts: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateLinkTokenQuery = { __typename?: 'Query', createLinkToken: { __typename?: 'Token', token: string } };

export type CreateLinkTokenForReconnectQueryVariables = Exact<{
  institutionId: Scalars['String'];
}>;


export type CreateLinkTokenForReconnectQuery = { __typename?: 'Query', createLinkTokenForReconnect: { __typename?: 'Token', token: string } };

export type MarkItemRepairedMutationVariables = Exact<{
  institutionId: Scalars['String'];
  activeAccountIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type MarkItemRepairedMutation = { __typename?: 'Mutation', markItemRepaired: boolean };

export type DeletePlaidInstitutionAuthMutationVariables = Exact<{
  institutionId: Scalars['String'];
}>;


export type DeletePlaidInstitutionAuthMutation = { __typename?: 'Mutation', deletePlaidInstitutionAuth: boolean };

export type ExchangePublicTokenMutationVariables = Exact<{
  token: Scalars['String'];
  institutionId: Scalars['String'];
  institutionName: Scalars['String'];
  activeAccountIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ExchangePublicTokenMutation = { __typename?: 'Mutation', exchangePublicToken: boolean };

export type CreateRecurringAchCreditPaymentMutationVariables = Exact<{
  data: RecurringAchCreditPaymentInput;
}>;


export type CreateRecurringAchCreditPaymentMutation = { __typename?: 'Mutation', createRecurringAchCreditPayment: { __typename?: 'RecurringAchCreditPayment', id: string, type: string, isPendingApproval: boolean, attributes: { __typename?: 'RecurringCreditAchPaymentAttributes', createdAt: any, updatedAt: any, amount: number, description: string, status: RecurringPaymentStatus, numberOfPayments: number, addenda?: string | null, schedule: { __typename?: 'Schedule', startTime?: any | null, endTime?: any | null, interval: Interval, dayOfWeek?: string | null, dayOfMonth?: number | null, totalNumberOfPayments?: number | null, nextScheduledAction?: string | null } }, counterparty?: { __typename?: 'Counterparty', routingNumber: string, accountNumber: string, accountType: AccountType, name: string, approvalStatus: string } | null } };

export type ToggleRecurringAchCreditPaymentActivationStatusMutationVariables = Exact<{
  data: ToggleRecurringPaymentStatusInput;
}>;


export type ToggleRecurringAchCreditPaymentActivationStatusMutation = { __typename?: 'Mutation', toggleRecurringAchCreditPaymentActivationStatus: { __typename?: 'RecurringAchCreditPayment', id: string, type: string, attributes: { __typename?: 'RecurringCreditAchPaymentAttributes', createdAt: any, updatedAt: any, amount: number, description: string, status: RecurringPaymentStatus, numberOfPayments: number, addenda?: string | null, schedule: { __typename?: 'Schedule', startTime?: any | null, endTime?: any | null, interval: Interval, dayOfWeek?: string | null, dayOfMonth?: number | null, totalNumberOfPayments?: number | null, nextScheduledAction?: string | null } }, counterparty?: { __typename?: 'Counterparty', routingNumber: string, accountNumber: string, accountType: AccountType, name: string } | null } };

export type GetRecurringPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecurringPaymentsQuery = { __typename?: 'Query', recurringAchCreditPayments: Array<{ __typename?: 'RecurringAchCreditPayment', id: string, isPendingApproval: boolean, attributes: { __typename?: 'RecurringCreditAchPaymentAttributes', status: RecurringPaymentStatus, amount: number, addenda?: string | null, schedule: { __typename?: 'Schedule', interval: Interval, dayOfMonth?: number | null, dayOfWeek?: string | null, endTime?: any | null } }, counterparty?: { __typename?: 'Counterparty', name: string, approvalStatus: string } | null }> };

export type ToggleRecurringPaymentStatusMutationVariables = Exact<{
  recurringPaymentId: Scalars['ID'];
  active: Scalars['Boolean'];
}>;


export type ToggleRecurringPaymentStatusMutation = { __typename?: 'Mutation', toggleRecurringAchCreditPaymentActivationStatus: { __typename?: 'RecurringAchCreditPayment', id: string, attributes: { __typename?: 'RecurringCreditAchPaymentAttributes', status: RecurringPaymentStatus } } };

export type BalanceDetailsQueryVariables = Exact<{
  since: Scalars['DateTime'];
  until: Scalars['DateTime'];
  timeframeUnit: TimeframeUnit;
  timezone: Scalars['String'];
  type: Scalars['String'];
}>;


export type BalanceDetailsQuery = { __typename?: 'Query', balanceDetails?: { __typename?: 'Chart', datasets: Array<{ __typename?: 'Dataset', label: string, data: Array<{ __typename?: 'DataPoint', count: number, label: string, value: number }> }> } | null };

export type HbPaymentsSnapshotQueryVariables = Exact<{
  since: Scalars['Date'];
  until: Scalars['Date'];
  timeframeUnit: TimeframeUnit;
  timezone: Scalars['String'];
}>;


export type HbPaymentsSnapshotQuery = { __typename?: 'Query', hbPayments?: { __typename?: 'Chart', datasets: Array<{ __typename?: 'Dataset', label: string, data: Array<{ __typename?: 'DataPoint', label: string, value: number }> }> } | null };

export type TaxDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type TaxDocumentsQuery = { __typename?: 'Query', taxDocuments: Array<{ __typename?: 'TaxDocument', id: string, type: string, name: string, year: number, status: string }> };

export type TaxDocumentUrlQueryVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type TaxDocumentUrlQuery = { __typename?: 'Query', taxDocumentUrl: string };

export type TaxDocumentUrlsQueryVariables = Exact<{
  documentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TaxDocumentUrlsQuery = { __typename?: 'Query', taxDocumentUrls: Array<string> };

export type GenerateReportMutationVariables = Exact<{
  filters: ReportFiltersInput;
}>;


export type GenerateReportMutation = { __typename?: 'Mutation', generateReport: { __typename?: 'ReportDownload', uri: string } };

export type TransferMoneyAccountDetailsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type TransferMoneyAccountDetailsQuery = { __typename?: 'Query', accountById: { __typename?: 'Account', attributes: { __typename?: 'AccountAttributes', accountNumber: string, available: number } } };

export type CreateLinkedPaymentMutationVariables = Exact<{
  data: AchLinkedPaymentInput;
}>;


export type CreateLinkedPaymentMutation = { __typename?: 'Mutation', createLinkedPayment?: { __typename?: 'AchPayment', id: string, attributes: { __typename?: 'AchPaymentAttributes', status: PaymentStatus, reason?: string | null } } | null };

export type AccountLimitsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type AccountLimitsQuery = { __typename?: 'Query', accountById: { __typename?: 'Account', accountLimits?: { __typename?: 'AccountLimits', attributes: { __typename?: 'AccountLimitsAttributes', ach: { __typename?: 'AchLimits', limits: { __typename?: 'AchLimitsAttributes', dailyCredit: number, monthlyCredit: number }, totalsDaily: { __typename?: 'LimitTotalTransfer', credits: number }, totalsMonthly: { __typename?: 'LimitTotalTransfer', credits: number } } } } | null } };

export type CreateCounterpartyMutationVariables = Exact<{
  data: AchCounterPartyInput;
}>;


export type CreateCounterpartyMutation = { __typename?: 'Mutation', createCounterParty: { __typename?: 'AchCounterparty', id: string, type: string, attributes: { __typename?: 'AchCounterpartyAttributes', name: string, routingNumber: string, accountNumber: string, accountType: AccountType, type: CounterpartyType, tags?: { __typename?: 'CounterpartyTags', relationship?: string | null, email?: string | null, approvalStatus?: CounterpartyApprovalStatus | null } | null } } };

export type UpdateCounterpartyMutationVariables = Exact<{
  data: UpdateAchCounterypartyArgs;
}>;


export type UpdateCounterpartyMutation = { __typename?: 'Mutation', updateCounterparty: { __typename?: 'AchCounterparty', id: string, type: string, attributes: { __typename?: 'AchCounterpartyAttributes', name: string, routingNumber: string, accountNumber: string, accountType: AccountType, type: CounterpartyType, tags?: { __typename?: 'CounterpartyTags', relationship?: string | null, email?: string | null } | null } } };

export type DeleteCounterpartyMutationVariables = Exact<{
  data: DeleteAchCounterypartyArgs;
}>;


export type DeleteCounterpartyMutation = { __typename?: 'Mutation', deleteCounterparty: string };

export type FreezeCardMutationVariables = Exact<{
  data: CardActionInput;
}>;


export type FreezeCardMutation = { __typename?: 'Mutation', freezeCard: { __typename?: 'BusinessDebitCard', id: string, attributes: { __typename?: 'CardAttributes', status: CardStatus } } | { __typename?: 'BusinessVirtualDebitCard', id: string, attributes: { __typename?: 'BusinessVirtualDebitCardAttributes', status: CardStatus } } | { __typename?: 'IndividualDebitCard', id: string, attributes: { __typename?: 'CardAttributes', status: CardStatus } } | { __typename?: 'IndividualVirtualDebitCard', id: string, attributes: { __typename?: 'CardAttributes', status: CardStatus } } };

export type UnfreezeCardMutationVariables = Exact<{
  data: CardActionInput;
}>;


export type UnfreezeCardMutation = { __typename?: 'Mutation', unfreezeCard: { __typename?: 'BusinessDebitCard', id: string, attributes: { __typename?: 'CardAttributes', status: CardStatus } } | { __typename?: 'BusinessVirtualDebitCard', id: string, attributes: { __typename?: 'BusinessVirtualDebitCardAttributes', status: CardStatus } } | { __typename?: 'IndividualDebitCard', id: string, attributes: { __typename?: 'CardAttributes', status: CardStatus } } | { __typename?: 'IndividualVirtualDebitCard', id: string, attributes: { __typename?: 'CardAttributes', status: CardStatus } } };

export type CloseCardMutationVariables = Exact<{
  data: CardActionInput;
}>;


export type CloseCardMutation = { __typename?: 'Mutation', closeCard: { __typename?: 'BusinessDebitCard', id: string, attributes: { __typename?: 'CardAttributes', status: CardStatus } } | { __typename?: 'BusinessVirtualDebitCard', id: string, attributes: { __typename?: 'BusinessVirtualDebitCardAttributes', status: CardStatus } } | { __typename?: 'IndividualDebitCard', id: string, attributes: { __typename?: 'CardAttributes', status: CardStatus } } | { __typename?: 'IndividualVirtualDebitCard', id: string, attributes: { __typename?: 'CardAttributes', status: CardStatus } } };

export type AddCounterpartyRelationshipsMutationVariables = Exact<{
  data: AddCounterypartyRelationshipsArgs;
}>;


export type AddCounterpartyRelationshipsMutation = { __typename?: 'Mutation', addCounterpartyRelationships: Array<string> };

export type RemoveCounterpartyRelationshipsMutationVariables = Exact<{
  data: RemoveCounterypartyRelationshipsArgs;
}>;


export type RemoveCounterpartyRelationshipsMutation = { __typename?: 'Mutation', removeCounterpartyRelationships: Array<string> };

export type CounterpartyRelationshipsQueryVariables = Exact<{ [key: string]: never; }>;


export type CounterpartyRelationshipsQuery = { __typename?: 'Query', counterpartyRelationships: Array<string> };

export type CounterPartiesQueryVariables = Exact<{ [key: string]: never; }>;


export type CounterPartiesQuery = { __typename?: 'Query', counterparties: Array<{ __typename?: 'AchCounterparty', id: string, type: string, attributes: { __typename?: 'AchCounterpartyAttributes', name: string, routingNumber: string, accountNumber: string, accountType: AccountType, type: CounterpartyType, tags?: { __typename?: 'CounterpartyTags', relationship?: string | null, email?: string | null, approvalStatus?: CounterpartyApprovalStatus | null } | null } }> };

export type CardTransactionsQueryVariables = Exact<{
  accountId: Scalars['ID'];
  type?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CardTransactionsQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'AchTransaction', id: string } | { __typename?: 'BaseTransaction', id: string } | { __typename?: 'PurchaseTransaction', id: string }> };

export type CreateTokenVerificationMutationVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
  channel: UnitVerificationTokenChannel;
}>;


export type CreateTokenVerificationMutation = { __typename?: 'Mutation', createTokenVerification?: string | null };

export type CreateCustomerTokenMutationVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
  verificationToken: Scalars['ID'];
  verificationCode: Scalars['ID'];
  purpose: CustomerTokenPurpose;
  fingerprint?: InputMaybe<Scalars['ID']>;
}>;


export type CreateCustomerTokenMutation = { __typename?: 'Mutation', createCustomerToken?: { __typename?: 'CustomerToken', isMasked: boolean, token?: string | null } | null };

export type GetCustomerPhoneNumberQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
}>;


export type GetCustomerPhoneNumberQuery = { __typename?: 'Query', customer?: { __typename?: 'BusinessCustomer', type: CustomerTypeEnum, attributes: { __typename?: 'BusinessCustomerAttributes', contact: { __typename?: 'BusinessContact', phone: { __typename?: 'Phone', number: string } } } } | { __typename?: 'IndividualCustomer', type: CustomerTypeEnum, attributes: { __typename?: 'IndividualCustomerAttributes', phone: { __typename?: 'Phone', number: string } } } | null };

export type GetExistingCustomerTokenQueryVariables = Exact<{
  purpose: CustomerTokenPurpose;
}>;


export type GetExistingCustomerTokenQuery = { __typename?: 'Query', getExistingCustomerToken?: { __typename?: 'CustomerToken', isMasked: boolean, token?: string | null } | null };

export type CashflowChartQueryVariables = Exact<{
  since: Scalars['Date'];
  until: Scalars['Date'];
  timeframeUnit: TimeframeUnit;
}>;


export type CashflowChartQuery = { __typename?: 'Query', cashflowChart?: { __typename?: 'Chart', refreshTimestampHumanized?: string | null, datasets: Array<{ __typename?: 'Dataset', label: string, data: Array<{ __typename?: 'DataPoint', count: number, label: string, value: number }> }> } | null };

export type ExternalAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalAccountsQuery = { __typename?: 'Query', externalAccounts: Array<{ __typename?: 'ExternalAccount', displayName: string, subtype: string, institutionName?: string | null, institutionId: string, currentBalance: number, availableBalance: number, logo?: string | null, lastUpdated?: any | null, status: PlaidInstitutionAuthStatus }> };

export type HbPaymentsChartQueryVariables = Exact<{
  since: Scalars['Date'];
  until: Scalars['Date'];
  timeframeUnit: TimeframeUnit;
  timezone: Scalars['String'];
}>;


export type HbPaymentsChartQuery = { __typename?: 'Query', hbPayments?: { __typename?: 'Chart', refreshTimestampHumanized?: string | null, datasets: Array<{ __typename?: 'Dataset', label: string, data: Array<{ __typename?: 'DataPoint', count: number, label: string, value: number }> }> } | null };

export type ListTransactionsQueryVariables = Exact<{
  accountId: Scalars['ID'];
  excludeTaxes?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type ListTransactionsQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'AchTransaction', id: string, type: string, accountId: string, recurringPaymentId?: string | null, attributes: { __typename?: 'AchTransactionAttributes', direction: FundsFlowDirection, amount: number, balance: number, summary: string, createdAt: any, category?: string | null, description: string, title: string, taxCategory?: string | null }, project?: { __typename?: 'Project', id: string, name: string, workspaceId?: string | null, isDeleted?: boolean | null } | null } | { __typename?: 'BaseTransaction', id: string, type: string, accountId: string, recurringPaymentId?: string | null, attributes: { __typename?: 'TransactionAttributes', direction: FundsFlowDirection, amount: number, balance: number, summary: string, createdAt: any, category?: string | null, taxCategory?: string | null, title: string }, project?: { __typename?: 'Project', id: string, name: string, workspaceId?: string | null, isDeleted?: boolean | null } | null } | { __typename?: 'PurchaseTransaction', id: string, type: string, accountId: string, recurringPaymentId?: string | null, attributes: { __typename?: 'PurchaseTransactionAttributes', direction: FundsFlowDirection, amount: number, balance: number, summary: string, createdAt: any, category?: string | null, title: string, taxCategory?: string | null }, project?: { __typename?: 'Project', id: string, name: string, workspaceId?: string | null, isDeleted?: boolean | null } | null }> };

export type ListAuthorizationsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type ListAuthorizationsQuery = { __typename?: 'Query', authorizations: Array<{ __typename?: 'Authorization', id: string, type: string, accountId: string, attributes: { __typename?: 'AuthorizationAttributes', amount: number, createdAt: any, digitalWallet?: DigitalWallet | null, paymentMethod?: PaymentMethod | null, cardLast4Digits: string, merchant: { __typename?: 'Merchant', name: string, type: number, category: string, location?: string | null } } }> };

export type UpdateExpenseCategoryMutationVariables = Exact<{
  data: UpdateTransactionInput;
}>;


export type UpdateExpenseCategoryMutation = { __typename?: 'Mutation', updateTransaction: { __typename?: 'AchTransaction', id: string, type: string, attributes: { __typename?: 'AchTransactionAttributes', category?: string | null } } | { __typename?: 'BaseTransaction', id: string, type: string, attributes: { __typename?: 'TransactionAttributes', category?: string | null } } | { __typename?: 'PurchaseTransaction', id: string, type: string, attributes: { __typename?: 'PurchaseTransactionAttributes', category?: string | null } } };

export type UpdateTaxCategoryMutationVariables = Exact<{
  data: UpdateTransactionInput;
}>;


export type UpdateTaxCategoryMutation = { __typename?: 'Mutation', updateTransaction: { __typename?: 'AchTransaction', id: string, type: string, attributes: { __typename?: 'AchTransactionAttributes', taxCategory?: string | null } } | { __typename?: 'BaseTransaction', id: string, type: string, attributes: { __typename?: 'TransactionAttributes', taxCategory?: string | null } } | { __typename?: 'PurchaseTransaction', id: string, type: string, attributes: { __typename?: 'PurchaseTransactionAttributes', taxCategory?: string | null } } };

export type UpdateExpenseProjectMutationVariables = Exact<{
  data: UpdateTransactionInput;
}>;


export type UpdateExpenseProjectMutation = { __typename?: 'Mutation', updateTransaction: { __typename?: 'AchTransaction', id: string, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'BaseTransaction', id: string, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'PurchaseTransaction', id: string, project?: { __typename?: 'Project', id: string, name: string } | null } };

export type GetProjectsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']>;
  query: Scalars['String'];
}>;


export type GetProjectsQuery = { __typename?: 'Query', search: Array<{ __typename?: 'Project', id: string, name: string }> };

export type AuthorizationDetailsQueryVariables = Exact<{
  authorizationId: Scalars['ID'];
  customerId: Scalars['ID'];
}>;


export type AuthorizationDetailsQuery = { __typename?: 'Query', getAuthorization: { __typename?: 'Authorization', id: string, type: string, attributes: { __typename?: 'AuthorizationAttributes', amount: number, createdAt: any, digitalWallet?: DigitalWallet | null, paymentMethod?: PaymentMethod | null, cardLast4Digits: string, merchant: { __typename?: 'Merchant', name: string, type: number, category: string, location?: string | null } } } };

export type TransactionDetailsQueryVariables = Exact<{
  accountId: Scalars['ID'];
  transactionId: Scalars['ID'];
}>;


export type TransactionDetailsQuery = { __typename?: 'Query', transaction: { __typename?: 'AchTransaction', id: string, type: string, expectedCompletionDate?: any | null, accountId: string, attributes: { __typename?: 'AchTransactionAttributes', direction: FundsFlowDirection, amount: number, balance: number, summary: string, createdAt: any, category?: string | null, taxCategory?: string | null, traceNumber?: string | null, description: string, title: string, counterparty: { __typename?: 'AchTransactionCounterparty', routingNumber: string, accountNumber: string, accountType: string }, tags?: { __typename?: 'TransactionTags', purpose?: string | null, taxWithholdAmount?: string | null, otherBucketsWithholdAmount?: string | null, counterpartyRelationship?: string | null } | null }, withholdings?: Array<{ __typename?: 'BucketWithhold', withholdAmount?: number | null, bucketName?: string | null, withholdPercentage?: string | null, bucketIcon?: string | null }> | null, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'BaseTransaction', id: string, type: string, accountId: string, attributes: { __typename?: 'TransactionAttributes', direction: FundsFlowDirection, amount: number, balance: number, summary: string, createdAt: any, category?: string | null, taxCategory?: string | null, title: string, tags?: { __typename?: 'TransactionTags', purpose?: string | null, taxWithholdAmount?: string | null, otherBucketsWithholdAmount?: string | null } | null }, withholdings?: Array<{ __typename?: 'BucketWithhold', withholdAmount?: number | null, bucketName?: string | null, withholdPercentage?: string | null, bucketIcon?: string | null }> | null, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'PurchaseTransaction', id: string, type: string, accountId: string, attributes: { __typename?: 'PurchaseTransactionAttributes', direction: FundsFlowDirection, amount: number, balance: number, summary: string, createdAt: any, digitalWallet?: DigitalWallet | null, paymentMethod?: PaymentMethod | null, cardLast4Digits: string, category?: string | null, taxCategory?: string | null, title: string, merchant: { __typename?: 'Merchant', name: string, type: number, category: string, location?: string | null }, tags?: { __typename?: 'TransactionTags', purpose?: string | null, taxWithholdAmount?: string | null, otherBucketsWithholdAmount?: string | null } | null }, withholdings?: Array<{ __typename?: 'BucketWithhold', withholdAmount?: number | null, bucketName?: string | null, withholdPercentage?: string | null, bucketIcon?: string | null }> | null, project?: { __typename?: 'Project', id: string, name: string } | null } };

export type GetProjectOptionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']>;
  query: Scalars['String'];
  mockData: Scalars['Boolean'];
}>;


export type GetProjectOptionsQuery = { __typename?: 'Query', search: Array<{ __typename?: 'Project', id: string, name: string }> };

export type ListTransactionsProjectQueryVariables = Exact<{
  accountId: Scalars['ID'];
  excludeTaxes: Scalars['Boolean'];
}>;


export type ListTransactionsProjectQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'AchTransaction', id: string, type: string, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'BaseTransaction', id: string, type: string, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'PurchaseTransaction', id: string, type: string, project?: { __typename?: 'Project', id: string, name: string } | null }> };


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Application": [
      "BusinessApplication",
      "IndividualApplication"
    ],
    "Card": [
      "BusinessDebitCard",
      "BusinessVirtualDebitCard",
      "IndividualDebitCard",
      "IndividualVirtualDebitCard"
    ],
    "Customer": [
      "BusinessCustomer",
      "IndividualCustomer"
    ],
    "Goal": [
      "YearlyRevenueGoal"
    ],
    "Transaction": [
      "AchTransaction",
      "BaseTransaction",
      "PurchaseTransaction"
    ]
  }
};
      export default result;
    